/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get default settings for aggregate commands devices (Auth)
     * @param body (optional) 
     * @return Device settings
     */
    aggregateCommandsDefault(linkableobjectid: string, body: AggregateCommandDTO | undefined , cancelToken?: CancelToken | undefined): Promise<DefaultDevicesSettingsDTO[]> {
        let url_ = this.baseUrl + "/devicesettings/aggregate-commands-default/{linkableobjectid}";
        if (linkableobjectid === undefined || linkableobjectid === null)
            throw new Error("The parameter 'linkableobjectid' must be defined.");
        url_ = url_.replace("{linkableobjectid}", encodeURIComponent("" + linkableobjectid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAggregateCommandsDefault(_response);
        });
    }

    protected processAggregateCommandsDefault(response: AxiosResponse): Promise<DefaultDevicesSettingsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultDevicesSettingsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultDevicesSettingsDTO[]>(<any>null);
    }

    /**
     * Get default settings for room object's devices (Auth)
     * @param body (optional) 
     * @return RoomObject
     */
    roomObjectDefault(linkableobjectid: string, body: AddRoomObjectDTO | undefined , cancelToken?: CancelToken | undefined): Promise<DefaultDevicesSettingsDTO[]> {
        let url_ = this.baseUrl + "/devicesettings/room-object-default/{linkableobjectid}";
        if (linkableobjectid === undefined || linkableobjectid === null)
            throw new Error("The parameter 'linkableobjectid' must be defined.");
        url_ = url_.replace("{linkableobjectid}", encodeURIComponent("" + linkableobjectid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomObjectDefault(_response);
        });
    }

    protected processRoomObjectDefault(response: AxiosResponse): Promise<DefaultDevicesSettingsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultDevicesSettingsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultDevicesSettingsDTO[]>(<any>null);
    }

    /**
     * Get default settings for room object's thermo devices (Auth)
     * @param body (optional) 
     * @return Device settings
     */
    thermoDefault(linkableobjectid: string, body: ThermoRoomObjectDTO | undefined , cancelToken?: CancelToken | undefined): Promise<DefaultDevicesSettingsDTO[]> {
        let url_ = this.baseUrl + "/devicesettings/thermo-default/{linkableobjectid}";
        if (linkableobjectid === undefined || linkableobjectid === null)
            throw new Error("The parameter 'linkableobjectid' must be defined.");
        url_ = url_.replace("{linkableobjectid}", encodeURIComponent("" + linkableobjectid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThermoDefault(_response);
        });
    }

    protected processThermoDefault(response: AxiosResponse): Promise<DefaultDevicesSettingsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultDevicesSettingsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultDevicesSettingsDTO[]>(<any>null);
    }
}

export class Action implements IAction {
    id?: number;

    constructor(data?: IAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IAction {
    id?: number;
}

/** 0 = None 1 = Separate 2 = Shared 3 = Mixed */
export enum ActuatorModalityType {
    None = 0,
    Separate = 1,
    Shared = 2,
    Mixed = 3,
}

export class ActuatorSettings implements IActuatorSettings {

    constructor(data?: IActuatorSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IActuatorSettings {
}

export class AddRoomObjectDTO implements IAddRoomObjectDTO {
    name?: string | undefined;
    type?: RoomObjectType;
    devices?: Device[] | undefined;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;

    constructor(data?: IAddRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
            this.isHidden = _data["isHidden"];
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
        }
    }

    static fromJS(data: any): AddRoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["isHidden"] = this.isHidden;
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        return data; 
    }
}

export interface IAddRoomObjectDTO {
    name?: string | undefined;
    type?: RoomObjectType;
    devices?: Device[] | undefined;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
}

export class AddressPumps implements IAddressPumps {
    number?: string | undefined;
    idSlot?: string | undefined;
    deviceid?: string | undefined;
    linksId?: string[] | undefined;

    constructor(data?: IAddressPumps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.idSlot = _data["idSlot"];
            this.deviceid = _data["deviceid"];
            if (Array.isArray(_data["linksId"])) {
                this.linksId = [] as any;
                for (let item of _data["linksId"])
                    this.linksId!.push(item);
            }
        }
    }

    static fromJS(data: any): AddressPumps {
        data = typeof data === 'object' ? data : {};
        let result = new AddressPumps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["idSlot"] = this.idSlot;
        data["deviceid"] = this.deviceid;
        if (Array.isArray(this.linksId)) {
            data["linksId"] = [];
            for (let item of this.linksId)
                data["linksId"].push(item);
        }
        return data; 
    }
}

export interface IAddressPumps {
    number?: string | undefined;
    idSlot?: string | undefined;
    deviceid?: string | undefined;
    linksId?: string[] | undefined;
}

export class LinkableObject implements ILinkableObject {
    id?: string | undefined;
    name?: string | undefined;
    devices?: Device[] | undefined;
    extDevices?: ExtDevice[] | undefined;

    constructor(data?: ILinkableObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
            if (Array.isArray(_data["extDevices"])) {
                this.extDevices = [] as any;
                for (let item of _data["extDevices"])
                    this.extDevices!.push(ExtDevice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkableObject {
        data = typeof data === 'object' ? data : {};
        let result = new LinkableObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        if (Array.isArray(this.extDevices)) {
            data["extDevices"] = [];
            for (let item of this.extDevices)
                data["extDevices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILinkableObject {
    id?: string | undefined;
    name?: string | undefined;
    devices?: Device[] | undefined;
    extDevices?: ExtDevice[] | undefined;
}

export class AggregateCommand extends LinkableObject implements IAggregateCommand {
    rooms?: Room[] | undefined;
    objectsName?: string[] | undefined;
    type?: AggregateCommandType;
    roomObjectType?: RoomObjectType;
    address?: string | undefined;
    roomId?: string | undefined;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    lightType?: LightType;
    hasCommands?: boolean;
    typeofProblem?: CompromisedType;
    isHidden?: boolean;
    readonly problemDescription?: string | undefined;

    constructor(data?: IAggregateCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(Room.fromJS(item));
            }
            if (Array.isArray(_data["objectsName"])) {
                this.objectsName = [] as any;
                for (let item of _data["objectsName"])
                    this.objectsName!.push(item);
            }
            this.type = _data["type"];
            this.roomObjectType = _data["roomObjectType"];
            this.address = _data["address"];
            this.roomId = _data["roomId"];
            this.isColor = _data["isColor"];
            this.isTemperatureColor = _data["isTemperatureColor"];
            this.lightType = _data["lightType"];
            this.hasCommands = _data["hasCommands"];
            this.typeofProblem = _data["typeofProblem"];
            this.isHidden = _data["isHidden"];
            (<any>this).problemDescription = _data["problemDescription"];
        }
    }

    static fromJS(data: any): AggregateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        if (Array.isArray(this.objectsName)) {
            data["objectsName"] = [];
            for (let item of this.objectsName)
                data["objectsName"].push(item);
        }
        data["type"] = this.type;
        data["roomObjectType"] = this.roomObjectType;
        data["address"] = this.address;
        data["roomId"] = this.roomId;
        data["isColor"] = this.isColor;
        data["isTemperatureColor"] = this.isTemperatureColor;
        data["lightType"] = this.lightType;
        data["hasCommands"] = this.hasCommands;
        data["typeofProblem"] = this.typeofProblem;
        data["isHidden"] = this.isHidden;
        data["problemDescription"] = this.problemDescription;
        super.toJSON(data);
        return data; 
    }
}

export interface IAggregateCommand extends ILinkableObject {
    rooms?: Room[] | undefined;
    objectsName?: string[] | undefined;
    type?: AggregateCommandType;
    roomObjectType?: RoomObjectType;
    address?: string | undefined;
    roomId?: string | undefined;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    lightType?: LightType;
    hasCommands?: boolean;
    typeofProblem?: CompromisedType;
    isHidden?: boolean;
    problemDescription?: string | undefined;
}

export class AggregateCommandDTO implements IAggregateCommandDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: AggregateCommandType;
    isPlaceholder?: boolean;
    rooms?: RoomDTO[] | undefined;
    roomObjectType?: RoomObjectType;

    constructor(data?: IAggregateCommandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            this.type = _data["type"];
            this.isPlaceholder = _data["isPlaceholder"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(RoomDTO.fromJS(item));
            }
            this.roomObjectType = _data["roomObjectType"];
        }
    }

    static fromJS(data: any): AggregateCommandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateCommandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["isPlaceholder"] = this.isPlaceholder;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["roomObjectType"] = this.roomObjectType;
        return data; 
    }
}

export interface IAggregateCommandDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: AggregateCommandType;
    isPlaceholder?: boolean;
    rooms?: RoomDTO[] | undefined;
    roomObjectType?: RoomObjectType;
}

/** 0 = General 1 = Group */
export enum AggregateCommandType {
    General = 0,
    Group = 1,
}

export class AlarmAction extends Action implements IAlarmAction {
    isSuspended?: boolean;
    alarmType?: AlarmType;
    alarmState?: AlarmPartitionState;
    alarmPartitionOrSceneId?: string | undefined;
    alarmPin?: string | undefined;
    alarmName?: string | undefined;

    constructor(data?: IAlarmAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isSuspended = _data["isSuspended"];
            this.alarmType = _data["alarmType"];
            this.alarmState = _data["alarmState"];
            this.alarmPartitionOrSceneId = _data["alarmPartitionOrSceneId"];
            this.alarmPin = _data["alarmPin"];
            this.alarmName = _data["alarmName"];
        }
    }

    static fromJS(data: any): AlarmAction {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuspended"] = this.isSuspended;
        data["alarmType"] = this.alarmType;
        data["alarmState"] = this.alarmState;
        data["alarmPartitionOrSceneId"] = this.alarmPartitionOrSceneId;
        data["alarmPin"] = this.alarmPin;
        data["alarmName"] = this.alarmName;
        super.toJSON(data);
        return data; 
    }
}

export interface IAlarmAction extends IAction {
    isSuspended?: boolean;
    alarmType?: AlarmType;
    alarmState?: AlarmPartitionState;
    alarmPartitionOrSceneId?: string | undefined;
    alarmPin?: string | undefined;
    alarmName?: string | undefined;
}

export class ExtDevice implements IExtDevice {
    componentType?: ExtComponentType;
    deviceConfiguration?: { [key: string]: string; } | undefined;

    constructor(data?: IExtDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentType = _data["componentType"];
            if (_data["deviceConfiguration"]) {
                this.deviceConfiguration = {} as any;
                for (let key in _data["deviceConfiguration"]) {
                    if (_data["deviceConfiguration"].hasOwnProperty(key))
                        (<any>this.deviceConfiguration)![key] = _data["deviceConfiguration"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new ExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentType"] = this.componentType;
        if (this.deviceConfiguration) {
            data["deviceConfiguration"] = {};
            for (let key in this.deviceConfiguration) {
                if (this.deviceConfiguration.hasOwnProperty(key))
                    (<any>data["deviceConfiguration"])[key] = this.deviceConfiguration[key];
            }
        }
        return data; 
    }
}

export interface IExtDevice {
    componentType?: ExtComponentType;
    deviceConfiguration?: { [key: string]: string; } | undefined;
}

export class AlarmCentralUnitExtDevice extends ExtDevice implements IAlarmCentralUnitExtDevice {
    readonly address?: string | undefined;

    constructor(data?: IAlarmCentralUnitExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            (<any>this).address = _data["address"];
        }
    }

    static fromJS(data: any): AlarmCentralUnitExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmCentralUnitExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        super.toJSON(data);
        return data; 
    }
}

export interface IAlarmCentralUnitExtDevice extends IExtDevice {
    address?: string | undefined;
}

export class Condition implements ICondition {
    id?: number;
    isSuspended?: boolean;

    constructor(data?: ICondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSuspended = _data["isSuspended"];
        }
    }

    static fromJS(data: any): Condition {
        data = typeof data === 'object' ? data : {};
        let result = new Condition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSuspended"] = this.isSuspended;
        return data; 
    }
}

export interface ICondition {
    id?: number;
    isSuspended?: boolean;
}

export class AlarmCondition extends Condition implements IAlarmCondition {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;

    constructor(data?: IAlarmCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alarmType = _data["alarmType"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmPartitionOrSceneId = _data["alarmPartitionOrSceneId"];
            this.alarmName = _data["alarmName"];
        }
    }

    static fromJS(data: any): AlarmCondition {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmType"] = this.alarmType;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmPartitionOrSceneId"] = this.alarmPartitionOrSceneId;
        data["alarmName"] = this.alarmName;
        super.toJSON(data);
        return data; 
    }
}

export interface IAlarmCondition extends ICondition {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;
}

/** 0 = Disarmed 1 = Exit 2 = Armed 3 = PreAlarm 4 = Ready_To_Arm 5 = Alarm 6 = Armed_Immediate 7 = Tamper 8 = None */
export enum AlarmPartitionState {
    Disarmed = 0,
    Exit = 1,
    Armed = 2,
    PreAlarm = 3,
    Ready_To_Arm = 4,
    Alarm = 5,
    Armed_Immediate = 6,
    Tamper = 7,
    None = 8,
}

/** 0 = Disarm 1 = Arm_With_Delay 2 = Arm_Without_Delay */
export enum AlarmPartitionStatus {
    Disarm = 0,
    Arm_With_Delay = 1,
    Arm_Without_Delay = 2,
}

export class AlarmSensorExtDevice extends ExtDevice implements IAlarmSensorExtDevice {
    readonly address?: string | undefined;
    readonly senrosName?: string | undefined;

    constructor(data?: IAlarmSensorExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            (<any>this).address = _data["address"];
            (<any>this).senrosName = _data["senrosName"];
        }
    }

    static fromJS(data: any): AlarmSensorExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSensorExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["senrosName"] = this.senrosName;
        super.toJSON(data);
        return data; 
    }
}

export interface IAlarmSensorExtDevice extends IExtDevice {
    address?: string | undefined;
    senrosName?: string | undefined;
}

/** 0 = Idle 1 = Tamper 2 = Trigger 3 = Mask */
export enum AlarmSensorStatus {
    Idle = 0,
    Tamper = 1,
    Trigger = 2,
    Mask = 3,
}

/** 0 = None 1 = Normal 2 = Alarm */
export enum AlarmSensorStatusScene {
    None = 0,
    Normal = 1,
    Alarm = 2,
}

export class Trigger implements ITrigger {
    id?: number;
    isSuspended?: boolean;
    address?: string | undefined;

    constructor(data?: ITrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSuspended = _data["isSuspended"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): Trigger {
        data = typeof data === 'object' ? data : {};
        let result = new Trigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSuspended"] = this.isSuspended;
        data["address"] = this.address;
        return data; 
    }
}

export interface ITrigger {
    id?: number;
    isSuspended?: boolean;
    address?: string | undefined;
}

export class AlarmTrigger extends Trigger implements IAlarmTrigger {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;

    constructor(data?: IAlarmTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alarmType = _data["alarmType"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmPartitionOrSceneId = _data["alarmPartitionOrSceneId"];
            this.alarmName = _data["alarmName"];
        }
    }

    static fromJS(data: any): AlarmTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmType"] = this.alarmType;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmPartitionOrSceneId"] = this.alarmPartitionOrSceneId;
        data["alarmName"] = this.alarmName;
        super.toJSON(data);
        return data; 
    }
}

export interface IAlarmTrigger extends ITrigger {
    alarmType?: AlarmType;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmPartitionOrSceneId?: string | undefined;
    alarmName?: string | undefined;
}

/** 0 = Partition 1 = AlarmSystemType */
export enum AlarmType {
    Partition = 0,
    AlarmSystemType = 1,
}

export class BaseShuttersCommandSettingsObjectDTO implements IBaseShuttersCommandSettingsObjectDTO {
    shutterMode?: ShutterMode;

    constructor(data?: IBaseShuttersCommandSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shutterMode = _data["shutterMode"];
        }
    }

    static fromJS(data: any): BaseShuttersCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseShuttersCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shutterMode"] = this.shutterMode;
        return data; 
    }
}

export interface IBaseShuttersCommandSettingsObjectDTO {
    shutterMode?: ShutterMode;
}

/** 0 = None 1 = Dimmer 2 = ColorTemperature 4 = Color 8 = Color1 16 = Color2 */
export enum BitmaskDaliLoadTypes {
    None = 0,
    Dimmer = 1,
    ColorTemperature = 2,
    Color = 4,
    Color1 = 8,
    Color2 = 16,
}

export class ButtonTrigger extends Trigger implements IButtonTrigger {
    devices?: Device[] | undefined;

    constructor(data?: IButtonTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ButtonTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IButtonTrigger extends ITrigger {
    devices?: Device[] | undefined;
}

/** 0 = Pointtopoint 1 = ToAll */
export enum CallType {
    Pointtopoint = 0,
    ToAll = 1,
}

export class Color implements IColor {
    readonly r?: number;
    readonly g?: number;
    readonly b?: number;
    readonly a?: number;
    readonly isKnownColor?: boolean;
    readonly isEmpty?: boolean;
    readonly isNamedColor?: boolean;
    readonly isSystemColor?: boolean;
    readonly name?: string | undefined;

    constructor(data?: IColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).r = _data["r"];
            (<any>this).g = _data["g"];
            (<any>this).b = _data["b"];
            (<any>this).a = _data["a"];
            (<any>this).isKnownColor = _data["isKnownColor"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).isNamedColor = _data["isNamedColor"];
            (<any>this).isSystemColor = _data["isSystemColor"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): Color {
        data = typeof data === 'object' ? data : {};
        let result = new Color();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["r"] = this.r;
        data["g"] = this.g;
        data["b"] = this.b;
        data["a"] = this.a;
        data["isKnownColor"] = this.isKnownColor;
        data["isEmpty"] = this.isEmpty;
        data["isNamedColor"] = this.isNamedColor;
        data["isSystemColor"] = this.isSystemColor;
        data["name"] = this.name;
        return data; 
    }
}

export interface IColor {
    r?: number;
    g?: number;
    b?: number;
    a?: number;
    isKnownColor?: boolean;
    isEmpty?: boolean;
    isNamedColor?: boolean;
    isSystemColor?: boolean;
    name?: string | undefined;
}

export class ColoredLightExtDevice extends ExtDevice implements IColoredLightExtDevice {
    coloredLightType?: ColoredLightType;
    readonly philipsHueBridge?: string | undefined;
    readonly philipsHueLamp?: string | undefined;
    readonly philipsHueLampName?: string | undefined;
    readonly lifxLamp?: string | undefined;
    readonly dmxMacAddress?: string | undefined;
    readonly dmxNode?: string | undefined;

    constructor(data?: IColoredLightExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.coloredLightType = _data["coloredLightType"];
            (<any>this).philipsHueBridge = _data["philipsHueBridge"];
            (<any>this).philipsHueLamp = _data["philipsHueLamp"];
            (<any>this).philipsHueLampName = _data["philipsHueLampName"];
            (<any>this).lifxLamp = _data["lifxLamp"];
            (<any>this).dmxMacAddress = _data["dmxMacAddress"];
            (<any>this).dmxNode = _data["dmxNode"];
        }
    }

    static fromJS(data: any): ColoredLightExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new ColoredLightExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coloredLightType"] = this.coloredLightType;
        data["philipsHueBridge"] = this.philipsHueBridge;
        data["philipsHueLamp"] = this.philipsHueLamp;
        data["philipsHueLampName"] = this.philipsHueLampName;
        data["lifxLamp"] = this.lifxLamp;
        data["dmxMacAddress"] = this.dmxMacAddress;
        data["dmxNode"] = this.dmxNode;
        super.toJSON(data);
        return data; 
    }
}

export interface IColoredLightExtDevice extends IExtDevice {
    coloredLightType?: ColoredLightType;
    philipsHueBridge?: string | undefined;
    philipsHueLamp?: string | undefined;
    philipsHueLampName?: string | undefined;
    lifxLamp?: string | undefined;
    dmxMacAddress?: string | undefined;
    dmxNode?: string | undefined;
}

/** 0 = None 1 = PhilipsHue 2 = Lifx 3 = Dmx */
export enum ColoredLightType {
    None = 0,
    PhilipsHue = 1,
    Lifx = 2,
    Dmx = 3,
}

/** 0 = None 1 = Up 2 = Down */
export enum CommandDirection {
    None = 0,
    Up = 1,
    Down = 2,
}

/** 0 = None 1 = Generic1 2 = Generic2 3 = Generic3 4 = Generic4 5 = Generic5 6 = Generic6 7 = Generic7 8 = Generic8 9 = Generic9 10 = Day 11 = Night 12 = Entrance 13 = Exit 14 = Key 15 = Fan 16 = Ring 17 = A 18 = B 19 = C 20 = D 21 = E 22 = F 23 = G 24 = H 25 = I 26 = J 27 = K 28 = L 29 = M 30 = N 31 = O 32 = P 33 = Q 34 = R 35 = S 36 = T 37 = U 38 = V 39 = W 40 = X 41 = Y 42 = Z 43 = Zero 44 = One 45 = Two 46 = Three 47 = Four 48 = Five 49 = Six 50 = Seven 51 = Eight 52 = Nine 53 = DefaultLoad 54 = Disabled1M 55 = Disabled2M 56 = Disabled3M 57 = LightGroup 58 = Shutter 59 = DimmerP2P 60 = DimmerGroup 61 = Player 62 = Disabled1Mb 63 = Disabled3Mb 64 = C_wrong */
export enum CommandIcon {
    None = 0,
    Generic1 = 1,
    Generic2 = 2,
    Generic3 = 3,
    Generic4 = 4,
    Generic5 = 5,
    Generic6 = 6,
    Generic7 = 7,
    Generic8 = 8,
    Generic9 = 9,
    Day = 10,
    Night = 11,
    Entrance = 12,
    Exit = 13,
    Key = 14,
    Fan = 15,
    Ring = 16,
    A = 17,
    B = 18,
    C = 19,
    D = 20,
    E = 21,
    F = 22,
    G = 23,
    H = 24,
    I = 25,
    J = 26,
    K = 27,
    L = 28,
    M = 29,
    N = 30,
    O = 31,
    P = 32,
    Q = 33,
    R = 34,
    S = 35,
    T = 36,
    U = 37,
    V = 38,
    W = 39,
    X = 40,
    Y = 41,
    Z = 42,
    Zero = 43,
    One = 44,
    Two = 45,
    Three = 46,
    Four = 47,
    Five = 48,
    Six = 49,
    Seven = 50,
    Eight = 51,
    Nine = 52,
    DefaultLoad = 53,
    Disabled1M = 54,
    Disabled2M = 55,
    Disabled3M = 56,
    LightGroup = 57,
    Shutter = 58,
    DimmerP2P = 59,
    DimmerGroup = 60,
    Player = 61,
    Disabled1Mb = 62,
    Disabled3Mb = 63,
    C_wrong = 64,
}

/** 0 = HalfSecond 1 = TwoSecond */
export enum CommandOpeningTime {
    HalfSecond = 0,
    TwoSecond = 1,
}

export class CommandSettings implements ICommandSettings {

    constructor(data?: ICommandSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface ICommandSettings {
}

/** 0 = None 1 = Thermo 2 = Probe 3 = Actuator 4 = ShutterActuator 5 = DimmerActuator 6 = Command 7 = ShutterCommand 8 = ShutterActuatorCommand 9 = DimmerCommand 10 = SceneCommand 11 = Contact 12 = PlayerCommand 13 = BlindActuator 14 = MusicPlayer 15 = SensorCommand 16 = ColoredLight 17 = Xmeter 18 = DimmerDaliActuator 19 = GatewayDaliActuator 20 = EnergyMeter 21 = LoadCentralUnit 22 = LoadControlActuactor 23 = LoadControlCommand 24 = LockVDECommand 25 = ActuatorLockVDE 26 = StaircaseLightCommand 27 = FloorCallCommand 28 = ColorCommand */
export enum ComponentType {
    None = 0,
    Thermo = 1,
    Probe = 2,
    Actuator = 3,
    ShutterActuator = 4,
    DimmerActuator = 5,
    Command = 6,
    ShutterCommand = 7,
    ShutterActuatorCommand = 8,
    DimmerCommand = 9,
    SceneCommand = 10,
    Contact = 11,
    PlayerCommand = 12,
    BlindActuator = 13,
    MusicPlayer = 14,
    SensorCommand = 15,
    ColoredLight = 16,
    Xmeter = 17,
    DimmerDaliActuator = 18,
    GatewayDaliActuator = 19,
    EnergyMeter = 20,
    LoadCentralUnit = 21,
    LoadControlActuactor = 22,
    LoadControlCommand = 23,
    LockVDECommand = 24,
    ActuatorLockVDE = 25,
    StaircaseLightCommand = 26,
    FloorCallCommand = 27,
    ColorCommand = 28,
}

/** 0 = NoActuator 1 = NoCommand 2 = NoActuatorAndCommand 3 = NoProblem 4 = NoButtonTrigger 5 = NoAction 6 = NoButtonTriggerAndAction 7 = SceneObjectProblem 8 = NoRoomAssigned 9 = NoRoomAssignedNoActuator 10 = NoRoomAssignedNoCommand 11 = NoRoomAssignedNoActuatorAndCommand 12 = ContactProblem */
export enum CompromisedType {
    NoActuator = 0,
    NoCommand = 1,
    NoActuatorAndCommand = 2,
    NoProblem = 3,
    NoButtonTrigger = 4,
    NoAction = 5,
    NoButtonTriggerAndAction = 6,
    SceneObjectProblem = 7,
    NoRoomAssigned = 8,
    NoRoomAssignedNoActuator = 9,
    NoRoomAssignedNoCommand = 10,
    NoRoomAssignedNoActuatorAndCommand = 11,
    ContactProblem = 12,
}

/** 0 = None 1 = NormallyOpen 2 = NormallyClose */
export enum ConctactType {
    None = 0,
    NormallyOpen = 1,
    NormallyClose = 2,
}

/** 0 = None 1 = Mostrine 2 = Preset */
export enum ConfigurationType {
    None = 0,
    Mostrine = 1,
    Preset = 2,
}

/** 0 = NoAction 1 = Protection 2 = Manual 3 = PreviousState */
export enum ContactType {
    NoAction = 0,
    Protection = 1,
    Manual = 2,
    PreviousState = 3,
}

/** 0 = None 1 = DaliDimmer 2 = DaliGateway */
export enum DaliType {
    None = 0,
    DaliDimmer = 1,
    DaliGateway = 2,
}

export class DateAndTimeTrigger extends Trigger implements IDateAndTimeTrigger {
    time?: string;
    weekDays?: WeekDay[] | undefined;

    constructor(data?: IDateAndTimeTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.time = _data["time"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays!.push(item);
            }
        }
    }

    static fromJS(data: any): DateAndTimeTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new DateAndTimeTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IDateAndTimeTrigger extends ITrigger {
    time?: string;
    weekDays?: WeekDay[] | undefined;
}

export class DefaultDevicesSettingsDTO implements IDefaultDevicesSettingsDTO {
    deviceUid?: string | undefined;
    thermoProbeSettings?: ThermoProbeSettingsObjectParam;
    shuttersActuatorSettings?: ShuttersActuatorSettingsObjectParam;
    lightsActuatorSettings?: LightsActuatorSettingsObjectDTO;
    lockCommandSettings?: LockCommandSettingsObjectDTO;
    lockActuatorSettings?: LockActuatorSettingsObjectParam;
    lightsCommandSettings?: LightsCommandSettingsObjectDTO;
    shuttersCommandSettings?: ShuttersCommandSettingsObjectDTO;
    selectedCommandIcon?: CommandIcon;
    hasChangeIconButtonVisible?: boolean;
    activeLinksLabel?: string | undefined;
    selectedComponentType?: ComponentType;
    thermoActuatorType?: ThermoActuatorType;
    isAggregateRoomObject?: boolean;
    roomType?: RoomType;
    identifier?: string | undefined;

    constructor(data?: IDefaultDevicesSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceUid = _data["deviceUid"];
            this.thermoProbeSettings = _data["thermoProbeSettings"] ? ThermoProbeSettingsObjectParam.fromJS(_data["thermoProbeSettings"]) : <any>undefined;
            this.shuttersActuatorSettings = _data["shuttersActuatorSettings"] ? ShuttersActuatorSettingsObjectParam.fromJS(_data["shuttersActuatorSettings"]) : <any>undefined;
            this.lightsActuatorSettings = _data["lightsActuatorSettings"] ? LightsActuatorSettingsObjectDTO.fromJS(_data["lightsActuatorSettings"]) : <any>undefined;
            this.lockCommandSettings = _data["lockCommandSettings"] ? LockCommandSettingsObjectDTO.fromJS(_data["lockCommandSettings"]) : <any>undefined;
            this.lockActuatorSettings = _data["lockActuatorSettings"] ? LockActuatorSettingsObjectParam.fromJS(_data["lockActuatorSettings"]) : <any>undefined;
            this.lightsCommandSettings = _data["lightsCommandSettings"] ? LightsCommandSettingsObjectDTO.fromJS(_data["lightsCommandSettings"]) : <any>undefined;
            this.shuttersCommandSettings = _data["shuttersCommandSettings"] ? ShuttersCommandSettingsObjectDTO.fromJS(_data["shuttersCommandSettings"]) : <any>undefined;
            this.selectedCommandIcon = _data["selectedCommandIcon"];
            this.hasChangeIconButtonVisible = _data["hasChangeIconButtonVisible"];
            this.activeLinksLabel = _data["activeLinksLabel"];
            this.selectedComponentType = _data["selectedComponentType"];
            this.thermoActuatorType = _data["thermoActuatorType"];
            this.isAggregateRoomObject = _data["isAggregateRoomObject"];
            this.roomType = _data["roomType"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): DefaultDevicesSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultDevicesSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceUid"] = this.deviceUid;
        data["thermoProbeSettings"] = this.thermoProbeSettings ? this.thermoProbeSettings.toJSON() : <any>undefined;
        data["shuttersActuatorSettings"] = this.shuttersActuatorSettings ? this.shuttersActuatorSettings.toJSON() : <any>undefined;
        data["lightsActuatorSettings"] = this.lightsActuatorSettings ? this.lightsActuatorSettings.toJSON() : <any>undefined;
        data["lockCommandSettings"] = this.lockCommandSettings ? this.lockCommandSettings.toJSON() : <any>undefined;
        data["lockActuatorSettings"] = this.lockActuatorSettings ? this.lockActuatorSettings.toJSON() : <any>undefined;
        data["lightsCommandSettings"] = this.lightsCommandSettings ? this.lightsCommandSettings.toJSON() : <any>undefined;
        data["shuttersCommandSettings"] = this.shuttersCommandSettings ? this.shuttersCommandSettings.toJSON() : <any>undefined;
        data["selectedCommandIcon"] = this.selectedCommandIcon;
        data["hasChangeIconButtonVisible"] = this.hasChangeIconButtonVisible;
        data["activeLinksLabel"] = this.activeLinksLabel;
        data["selectedComponentType"] = this.selectedComponentType;
        data["thermoActuatorType"] = this.thermoActuatorType;
        data["isAggregateRoomObject"] = this.isAggregateRoomObject;
        data["roomType"] = this.roomType;
        data["identifier"] = this.identifier;
        return data; 
    }
}

export interface IDefaultDevicesSettingsDTO {
    deviceUid?: string | undefined;
    thermoProbeSettings?: ThermoProbeSettingsObjectParam;
    shuttersActuatorSettings?: ShuttersActuatorSettingsObjectParam;
    lightsActuatorSettings?: LightsActuatorSettingsObjectDTO;
    lockCommandSettings?: LockCommandSettingsObjectDTO;
    lockActuatorSettings?: LockActuatorSettingsObjectParam;
    lightsCommandSettings?: LightsCommandSettingsObjectDTO;
    shuttersCommandSettings?: ShuttersCommandSettingsObjectDTO;
    selectedCommandIcon?: CommandIcon;
    hasChangeIconButtonVisible?: boolean;
    activeLinksLabel?: string | undefined;
    selectedComponentType?: ComponentType;
    thermoActuatorType?: ThermoActuatorType;
    isAggregateRoomObject?: boolean;
    roomType?: RoomType;
    identifier?: string | undefined;
}

export class ObjectAction extends Action implements IObjectAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    dimmerStatus?: DimmerStatus;
    dimmerPercentage?: number;
    dimmerFadeIn?: number;
    dimmerFadeOut?: number;
    selectedColor?: Color;
    workingMode?: DimmerWorkingMode;
    temperature?: number;
    sceneShutterState?: SceneShutterState;
    sceneShutterPosition?: number;
    isShutterPositionManagement?: boolean;
    sceneSocketState?: SceneSocketState;
    sceneBlindState?: SceneBlindState;
    sceneLockState?: SceneLockState;
    thermostatStatus?: ThermostatStatus;
    thermostatTypeOfObject?: ThermoTypeOfObject;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermostatTriggerTemperature?: number;
    sceneFancoilState?: SceneFancoilState;
    fancoilSpeed?: number;
    sceneTowelWarmerState?: SceneTowelWarmerState;
    sceneColoredLightsState?: SceneColoredLightsState;
    coloredLightsIntensity?: number;
    coloredLightsTemperature?: number;
    coloredLightsColor?: number;
    scenePlayerState?: ScenePlayerState;
    playerVolume?: number;
    playerSourceType?: number;
    playerSourceId?: string | undefined;
    playerSourceDescription?: string | undefined;
    alarmPin?: string | undefined;
    alarmPartitions?: Action[] | undefined;
    alarmPartitionStatus?: AlarmPartitionStatus;
    alarmSensorStatusScene?: AlarmSensorStatusScene;
    alarmPartitionorSceneId?: string | undefined;
    alarmType?: AlarmType;
    duration?: number | undefined;
    delay?: number | undefined;
    sceneLoadManagementStatus?: SceneLoadManagementState;

    constructor(data?: IObjectAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkableObjectId = _data["linkableObjectId"];
            this.sceneLightState = _data["sceneLightState"];
            this.dimmerStatus = _data["dimmerStatus"];
            this.dimmerPercentage = _data["dimmerPercentage"];
            this.dimmerFadeIn = _data["dimmerFadeIn"];
            this.dimmerFadeOut = _data["dimmerFadeOut"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.workingMode = _data["workingMode"];
            this.temperature = _data["temperature"];
            this.sceneShutterState = _data["sceneShutterState"];
            this.sceneShutterPosition = _data["sceneShutterPosition"];
            this.isShutterPositionManagement = _data["isShutterPositionManagement"];
            this.sceneSocketState = _data["sceneSocketState"];
            this.sceneBlindState = _data["sceneBlindState"];
            this.sceneLockState = _data["sceneLockState"];
            this.thermostatStatus = _data["thermostatStatus"];
            this.thermostatTypeOfObject = _data["thermostatTypeOfObject"];
            this.coolingSystemControlType = _data["coolingSystemControlType"];
            this.heatingSystemControlType = _data["heatingSystemControlType"];
            this.sharedSystemControlType = _data["sharedSystemControlType"];
            this.thermostatTriggerTemperature = _data["thermostatTriggerTemperature"];
            this.sceneFancoilState = _data["sceneFancoilState"];
            this.fancoilSpeed = _data["fancoilSpeed"];
            this.sceneTowelWarmerState = _data["sceneTowelWarmerState"];
            this.sceneColoredLightsState = _data["sceneColoredLightsState"];
            this.coloredLightsIntensity = _data["coloredLightsIntensity"];
            this.coloredLightsTemperature = _data["coloredLightsTemperature"];
            this.coloredLightsColor = _data["coloredLightsColor"];
            this.scenePlayerState = _data["scenePlayerState"];
            this.playerVolume = _data["playerVolume"];
            this.playerSourceType = _data["playerSourceType"];
            this.playerSourceId = _data["playerSourceId"];
            this.playerSourceDescription = _data["playerSourceDescription"];
            this.alarmPin = _data["alarmPin"];
            if (Array.isArray(_data["alarmPartitions"])) {
                this.alarmPartitions = [] as any;
                for (let item of _data["alarmPartitions"])
                    this.alarmPartitions!.push(Action.fromJS(item));
            }
            this.alarmPartitionStatus = _data["alarmPartitionStatus"];
            this.alarmSensorStatusScene = _data["alarmSensorStatusScene"];
            this.alarmPartitionorSceneId = _data["alarmPartitionorSceneId"];
            this.alarmType = _data["alarmType"];
            this.duration = _data["duration"];
            this.delay = _data["delay"];
            this.sceneLoadManagementStatus = _data["sceneLoadManagementStatus"];
        }
    }

    static fromJS(data: any): ObjectAction {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkableObjectId"] = this.linkableObjectId;
        data["sceneLightState"] = this.sceneLightState;
        data["dimmerStatus"] = this.dimmerStatus;
        data["dimmerPercentage"] = this.dimmerPercentage;
        data["dimmerFadeIn"] = this.dimmerFadeIn;
        data["dimmerFadeOut"] = this.dimmerFadeOut;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["workingMode"] = this.workingMode;
        data["temperature"] = this.temperature;
        data["sceneShutterState"] = this.sceneShutterState;
        data["sceneShutterPosition"] = this.sceneShutterPosition;
        data["isShutterPositionManagement"] = this.isShutterPositionManagement;
        data["sceneSocketState"] = this.sceneSocketState;
        data["sceneBlindState"] = this.sceneBlindState;
        data["sceneLockState"] = this.sceneLockState;
        data["thermostatStatus"] = this.thermostatStatus;
        data["thermostatTypeOfObject"] = this.thermostatTypeOfObject;
        data["coolingSystemControlType"] = this.coolingSystemControlType;
        data["heatingSystemControlType"] = this.heatingSystemControlType;
        data["sharedSystemControlType"] = this.sharedSystemControlType;
        data["thermostatTriggerTemperature"] = this.thermostatTriggerTemperature;
        data["sceneFancoilState"] = this.sceneFancoilState;
        data["fancoilSpeed"] = this.fancoilSpeed;
        data["sceneTowelWarmerState"] = this.sceneTowelWarmerState;
        data["sceneColoredLightsState"] = this.sceneColoredLightsState;
        data["coloredLightsIntensity"] = this.coloredLightsIntensity;
        data["coloredLightsTemperature"] = this.coloredLightsTemperature;
        data["coloredLightsColor"] = this.coloredLightsColor;
        data["scenePlayerState"] = this.scenePlayerState;
        data["playerVolume"] = this.playerVolume;
        data["playerSourceType"] = this.playerSourceType;
        data["playerSourceId"] = this.playerSourceId;
        data["playerSourceDescription"] = this.playerSourceDescription;
        data["alarmPin"] = this.alarmPin;
        if (Array.isArray(this.alarmPartitions)) {
            data["alarmPartitions"] = [];
            for (let item of this.alarmPartitions)
                data["alarmPartitions"].push(item.toJSON());
        }
        data["alarmPartitionStatus"] = this.alarmPartitionStatus;
        data["alarmSensorStatusScene"] = this.alarmSensorStatusScene;
        data["alarmPartitionorSceneId"] = this.alarmPartitionorSceneId;
        data["alarmType"] = this.alarmType;
        data["duration"] = this.duration;
        data["delay"] = this.delay;
        data["sceneLoadManagementStatus"] = this.sceneLoadManagementStatus;
        super.toJSON(data);
        return data; 
    }
}

export interface IObjectAction extends IAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    dimmerStatus?: DimmerStatus;
    dimmerPercentage?: number;
    dimmerFadeIn?: number;
    dimmerFadeOut?: number;
    selectedColor?: Color;
    workingMode?: DimmerWorkingMode;
    temperature?: number;
    sceneShutterState?: SceneShutterState;
    sceneShutterPosition?: number;
    isShutterPositionManagement?: boolean;
    sceneSocketState?: SceneSocketState;
    sceneBlindState?: SceneBlindState;
    sceneLockState?: SceneLockState;
    thermostatStatus?: ThermostatStatus;
    thermostatTypeOfObject?: ThermoTypeOfObject;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermostatTriggerTemperature?: number;
    sceneFancoilState?: SceneFancoilState;
    fancoilSpeed?: number;
    sceneTowelWarmerState?: SceneTowelWarmerState;
    sceneColoredLightsState?: SceneColoredLightsState;
    coloredLightsIntensity?: number;
    coloredLightsTemperature?: number;
    coloredLightsColor?: number;
    scenePlayerState?: ScenePlayerState;
    playerVolume?: number;
    playerSourceType?: number;
    playerSourceId?: string | undefined;
    playerSourceDescription?: string | undefined;
    alarmPin?: string | undefined;
    alarmPartitions?: Action[] | undefined;
    alarmPartitionStatus?: AlarmPartitionStatus;
    alarmSensorStatusScene?: AlarmSensorStatusScene;
    alarmPartitionorSceneId?: string | undefined;
    alarmType?: AlarmType;
    duration?: number | undefined;
    delay?: number | undefined;
    sceneLoadManagementStatus?: SceneLoadManagementState;
}

export class DefaultObjectAction extends ObjectAction implements IDefaultObjectAction {
    isEnabled?: boolean;

    constructor(data?: IDefaultObjectAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): DefaultObjectAction {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultObjectAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        super.toJSON(data);
        return data; 
    }
}

export interface IDefaultObjectAction extends IObjectAction {
    isEnabled?: boolean;
}

export class DelayValue implements IDelayValue {
    value?: number;
    description?: string | undefined;

    constructor(data?: IDelayValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DelayValue {
        data = typeof data === 'object' ? data : {};
        let result = new DelayValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        return data; 
    }
}

export interface IDelayValue {
    value?: number;
    description?: string | undefined;
}

export class Device implements IDevice {
    uid?: string | undefined;
    id?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    hasSubModule?: boolean;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isF422Acompatible?: boolean;
    problemType?: ProblemType;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    thermoSystemControlType?: SystemControlType[] | undefined;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    interface?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    hasChanges?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    readonly firmwareVersion?: string | undefined;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.id = _data["id"];
            this.model = _data["model"];
            this.modelObject = _data["modelObject"];
            this.hasSubModule = _data["hasSubModule"];
            this.isManaged = _data["isManaged"];
            this.isShutterWithPosition = _data["isShutterWithPosition"];
            this.canHandlePreset = _data["canHandlePreset"];
            this.isAnomaly = _data["isAnomaly"];
            this.isBlocking = _data["isBlocking"];
            this.isF422Acompatible = _data["isF422Acompatible"];
            this.problemType = _data["problemType"];
            this.isIgnored = _data["isIgnored"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(Slot.fromJS(item));
            }
            this.functionType = _data["functionType"];
            this.systemType = _data["systemType"];
            if (Array.isArray(_data["componentTypes"])) {
                this.componentTypes = [] as any;
                for (let item of _data["componentTypes"])
                    this.componentTypes!.push(item);
            }
            this.isDoubleDimmer = _data["isDoubleDimmer"];
            this.canHandleDoubleDimmer = _data["canHandleDoubleDimmer"];
            if (Array.isArray(_data["thermoSystemControlType"])) {
                this.thermoSystemControlType = [] as any;
                for (let item of _data["thermoSystemControlType"])
                    this.thermoSystemControlType!.push(item);
            }
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.ledIntensity = _data["ledIntensity"];
            this.interface = _data["interface"];
            this.ledModality = _data["ledModality"];
            this.hasRefresherFeedback = _data["hasRefresherFeedback"];
            this.hasChanges = _data["hasChanges"];
            this.fwVersion = _data["fwVersion"];
            if (_data["deviceConfiguration"]) {
                this.deviceConfiguration = {} as any;
                for (let key in _data["deviceConfiguration"]) {
                    if (_data["deviceConfiguration"].hasOwnProperty(key))
                        (<any>this.deviceConfiguration)![key] = _data["deviceConfiguration"][key];
                }
            }
            (<any>this).firmwareVersion = _data["firmwareVersion"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["id"] = this.id;
        data["model"] = this.model;
        data["modelObject"] = this.modelObject;
        data["hasSubModule"] = this.hasSubModule;
        data["isManaged"] = this.isManaged;
        data["isShutterWithPosition"] = this.isShutterWithPosition;
        data["canHandlePreset"] = this.canHandlePreset;
        data["isAnomaly"] = this.isAnomaly;
        data["isBlocking"] = this.isBlocking;
        data["isF422Acompatible"] = this.isF422Acompatible;
        data["problemType"] = this.problemType;
        data["isIgnored"] = this.isIgnored;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["functionType"] = this.functionType;
        data["systemType"] = this.systemType;
        if (Array.isArray(this.componentTypes)) {
            data["componentTypes"] = [];
            for (let item of this.componentTypes)
                data["componentTypes"].push(item);
        }
        data["isDoubleDimmer"] = this.isDoubleDimmer;
        data["canHandleDoubleDimmer"] = this.canHandleDoubleDimmer;
        if (Array.isArray(this.thermoSystemControlType)) {
            data["thermoSystemControlType"] = [];
            for (let item of this.thermoSystemControlType)
                data["thermoSystemControlType"].push(item);
        }
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["ledIntensity"] = this.ledIntensity;
        data["interface"] = this.interface;
        data["ledModality"] = this.ledModality;
        data["hasRefresherFeedback"] = this.hasRefresherFeedback;
        data["hasChanges"] = this.hasChanges;
        data["fwVersion"] = this.fwVersion;
        if (this.deviceConfiguration) {
            data["deviceConfiguration"] = {};
            for (let key in this.deviceConfiguration) {
                if (this.deviceConfiguration.hasOwnProperty(key))
                    (<any>data["deviceConfiguration"])[key] = this.deviceConfiguration[key];
            }
        }
        data["firmwareVersion"] = this.firmwareVersion;
        return data; 
    }
}

export interface IDevice {
    uid?: string | undefined;
    id?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    hasSubModule?: boolean;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isF422Acompatible?: boolean;
    problemType?: ProblemType;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    thermoSystemControlType?: SystemControlType[] | undefined;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    interface?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    hasChanges?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    firmwareVersion?: string | undefined;
}

/** 0 = None 1 = Min 2 = Max 3 = Med 4 = Off */
export enum DeviceBrightness {
    None = 0,
    Min = 1,
    Max = 2,
    Med = 3,
    Off = 4,
}

export class DeviceDTO implements IDeviceDTO {
    uid?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    problemType?: ProblemType;
    readonly isActuatorDevice?: boolean;
    readonly isCommandDevice?: boolean;
    readonly isThermostatDevice?: boolean;
    readonly isThermoProbeDevice?: boolean;
    readonly isAssigned?: boolean;
    readonly isAssignedCommand?: boolean;
    readonly isAssignedActuator?: boolean;
    readonly isAssignedActuatorAndCommand?: boolean;
    selectedComponentType?: ComponentType;
    settingsVisibility?: DeviceSettingsVisibilityDTO;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    defaultSettings?: DefaultDevicesSettingsDTO[] | undefined;

    constructor(data?: IDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.model = _data["model"];
            this.modelObject = _data["modelObject"];
            this.isManaged = _data["isManaged"];
            this.isShutterWithPosition = _data["isShutterWithPosition"];
            this.canHandlePreset = _data["canHandlePreset"];
            this.isAnomaly = _data["isAnomaly"];
            this.isBlocking = _data["isBlocking"];
            this.isIgnored = _data["isIgnored"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(Slot.fromJS(item));
            }
            this.functionType = _data["functionType"];
            this.systemType = _data["systemType"];
            if (Array.isArray(_data["componentTypes"])) {
                this.componentTypes = [] as any;
                for (let item of _data["componentTypes"])
                    this.componentTypes!.push(item);
            }
            this.isDoubleDimmer = _data["isDoubleDimmer"];
            this.canHandleDoubleDimmer = _data["canHandleDoubleDimmer"];
            this.problemType = _data["problemType"];
            (<any>this).isActuatorDevice = _data["isActuatorDevice"];
            (<any>this).isCommandDevice = _data["isCommandDevice"];
            (<any>this).isThermostatDevice = _data["isThermostatDevice"];
            (<any>this).isThermoProbeDevice = _data["isThermoProbeDevice"];
            (<any>this).isAssigned = _data["isAssigned"];
            (<any>this).isAssignedCommand = _data["isAssignedCommand"];
            (<any>this).isAssignedActuator = _data["isAssignedActuator"];
            (<any>this).isAssignedActuatorAndCommand = _data["isAssignedActuatorAndCommand"];
            this.selectedComponentType = _data["selectedComponentType"];
            this.settingsVisibility = _data["settingsVisibility"] ? DeviceSettingsVisibilityDTO.fromJS(_data["settingsVisibility"]) : <any>undefined;
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.hasRefresherFeedback = _data["hasRefresherFeedback"];
            this.fwVersion = _data["fwVersion"];
            if (_data["deviceConfiguration"]) {
                this.deviceConfiguration = {} as any;
                for (let key in _data["deviceConfiguration"]) {
                    if (_data["deviceConfiguration"].hasOwnProperty(key))
                        (<any>this.deviceConfiguration)![key] = _data["deviceConfiguration"][key];
                }
            }
            if (Array.isArray(_data["defaultSettings"])) {
                this.defaultSettings = [] as any;
                for (let item of _data["defaultSettings"])
                    this.defaultSettings!.push(DefaultDevicesSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["id"] = this.id;
        data["name"] = this.name;
        data["model"] = this.model;
        data["modelObject"] = this.modelObject;
        data["isManaged"] = this.isManaged;
        data["isShutterWithPosition"] = this.isShutterWithPosition;
        data["canHandlePreset"] = this.canHandlePreset;
        data["isAnomaly"] = this.isAnomaly;
        data["isBlocking"] = this.isBlocking;
        data["isIgnored"] = this.isIgnored;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["functionType"] = this.functionType;
        data["systemType"] = this.systemType;
        if (Array.isArray(this.componentTypes)) {
            data["componentTypes"] = [];
            for (let item of this.componentTypes)
                data["componentTypes"].push(item);
        }
        data["isDoubleDimmer"] = this.isDoubleDimmer;
        data["canHandleDoubleDimmer"] = this.canHandleDoubleDimmer;
        data["problemType"] = this.problemType;
        data["isActuatorDevice"] = this.isActuatorDevice;
        data["isCommandDevice"] = this.isCommandDevice;
        data["isThermostatDevice"] = this.isThermostatDevice;
        data["isThermoProbeDevice"] = this.isThermoProbeDevice;
        data["isAssigned"] = this.isAssigned;
        data["isAssignedCommand"] = this.isAssignedCommand;
        data["isAssignedActuator"] = this.isAssignedActuator;
        data["isAssignedActuatorAndCommand"] = this.isAssignedActuatorAndCommand;
        data["selectedComponentType"] = this.selectedComponentType;
        data["settingsVisibility"] = this.settingsVisibility ? this.settingsVisibility.toJSON() : <any>undefined;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["hasRefresherFeedback"] = this.hasRefresherFeedback;
        data["fwVersion"] = this.fwVersion;
        if (this.deviceConfiguration) {
            data["deviceConfiguration"] = {};
            for (let key in this.deviceConfiguration) {
                if (this.deviceConfiguration.hasOwnProperty(key))
                    (<any>data["deviceConfiguration"])[key] = this.deviceConfiguration[key];
            }
        }
        if (Array.isArray(this.defaultSettings)) {
            data["defaultSettings"] = [];
            for (let item of this.defaultSettings)
                data["defaultSettings"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceDTO {
    uid?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    model?: string | undefined;
    modelObject?: string | undefined;
    isManaged?: boolean;
    isShutterWithPosition?: boolean;
    canHandlePreset?: boolean;
    isAnomaly?: boolean;
    isBlocking?: boolean;
    isIgnored?: boolean;
    slots?: Slot[] | undefined;
    functionType?: FunctionType;
    systemType?: SystemType;
    componentTypes?: ComponentType[] | undefined;
    isDoubleDimmer?: boolean;
    canHandleDoubleDimmer?: boolean;
    problemType?: ProblemType;
    isActuatorDevice?: boolean;
    isCommandDevice?: boolean;
    isThermostatDevice?: boolean;
    isThermoProbeDevice?: boolean;
    isAssigned?: boolean;
    isAssignedCommand?: boolean;
    isAssignedActuator?: boolean;
    isAssignedActuatorAndCommand?: boolean;
    selectedComponentType?: ComponentType;
    settingsVisibility?: DeviceSettingsVisibilityDTO;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    deviceIconsVisibility?: DeviceIconsVisibility;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    hasRefresherFeedback?: boolean;
    fwVersion?: string | undefined;
    deviceConfiguration?: { [key: string]: string; } | undefined;
    defaultSettings?: DefaultDevicesSettingsDTO[] | undefined;
}

/** 0 = None 1 = AtTouch 2 = Always */
export enum DeviceIconsVisibility {
    None = 0,
    AtTouch = 1,
    Always = 2,
}

/** 0 = On 1 = OnDuringUpdate 2 = Off */
export enum DeviceLedModality {
    On = 0,
    OnDuringUpdate = 1,
    Off = 2,
}

/** 0 = None 1 = Min 2 = Med 3 = Max */
export enum DeviceProximity {
    None = 0,
    Min = 1,
    Med = 2,
    Max = 3,
}

export class DeviceSettingsVisibilityDTO implements IDeviceSettingsVisibilityDTO {
    hasSettings?: boolean;
    hasBrightness?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;

    constructor(data?: IDeviceSettingsVisibilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSettings = _data["hasSettings"];
            this.hasBrightness = _data["hasBrightness"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntensity = _data["hasLedIntensity"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
        }
    }

    static fromJS(data: any): DeviceSettingsVisibilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSettingsVisibilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSettings"] = this.hasSettings;
        data["hasBrightness"] = this.hasBrightness;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntensity"] = this.hasLedIntensity;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        return data; 
    }
}

export interface IDeviceSettingsVisibilityDTO {
    hasSettings?: boolean;
    hasBrightness?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntensity?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
}

export class DimmerDaliActuatorSettings extends ActuatorSettings implements IDimmerDaliActuatorSettings {
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    loadType?: LightsLoadTypes;
    hasPUL?: boolean;
    loadDaliTypes?: BitmaskDaliLoadTypes[] | undefined;

    constructor(data?: IDimmerDaliActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isRestoreStateAfterResetEnabled = _data["isRestoreStateAfterResetEnabled"];
            this.isMinimumregulationLevelEnabled = _data["isMinimumregulationLevelEnabled"];
            this.minimumRegulationLevelValue = _data["minimumRegulationLevelValue"];
            this.loadType = _data["loadType"];
            this.hasPUL = _data["hasPUL"];
            if (Array.isArray(_data["loadDaliTypes"])) {
                this.loadDaliTypes = [] as any;
                for (let item of _data["loadDaliTypes"])
                    this.loadDaliTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): DimmerDaliActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DimmerDaliActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRestoreStateAfterResetEnabled"] = this.isRestoreStateAfterResetEnabled;
        data["isMinimumregulationLevelEnabled"] = this.isMinimumregulationLevelEnabled;
        data["minimumRegulationLevelValue"] = this.minimumRegulationLevelValue;
        data["loadType"] = this.loadType;
        data["hasPUL"] = this.hasPUL;
        if (Array.isArray(this.loadDaliTypes)) {
            data["loadDaliTypes"] = [];
            for (let item of this.loadDaliTypes)
                data["loadDaliTypes"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IDimmerDaliActuatorSettings extends IActuatorSettings {
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    loadType?: LightsLoadTypes;
    hasPUL?: boolean;
    loadDaliTypes?: BitmaskDaliLoadTypes[] | undefined;
}

/** 0 = None 1 = On 2 = Off 3 = Dimmer */
export enum DimmerStatus {
    None = 0,
    On = 1,
    Off = 2,
    Dimmer = 3,
}

/** 0 = None 1 = Any 2 = WhiteTemperature 3 = ColorTemperature */
export enum DimmerWorkingMode {
    None = 0,
    Any = 1,
    WhiteTemperature = 2,
    ColorTemperature = 3,
}

export class EMailAction extends Action implements IEMailAction {

    constructor(data?: IEMailAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EMailAction {
        data = typeof data === 'object' ? data : {};
        let result = new EMailAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IEMailAction extends IAction {
}

/** 0 = None 1 = Socket 2 = Light 3 = Kitchenappliances 4 = Shutter 5 = Heating 6 = Boiler 7 = Airconditioner 8 = Other 9 = Fridge 10 = Oven 11 = Washingmachine 12 = Dryer 13 = Dishwasher 14 = Multimedia 15 = Internetbox */
export enum EnergyMeterAndLoadControlType {
    None = 0,
    Socket = 1,
    Light = 2,
    Kitchenappliances = 3,
    Shutter = 4,
    Heating = 5,
    Boiler = 6,
    Airconditioner = 7,
    Other = 8,
    Fridge = 9,
    Oven = 10,
    Washingmachine = 11,
    Dryer = 12,
    Dishwasher = 13,
    Multimedia = 14,
    Internetbox = 15,
}

/** 0 = ColoredLight 1 = Xmeter 2 = Player 3 = AlarmCentralUnit 4 = AlarmSensor 5 = DimmerDmx */
export enum ExtComponentType {
    ColoredLight = 0,
    Xmeter = 1,
    Player = 2,
    AlarmCentralUnit = 3,
    AlarmSensor = 4,
    DimmerDmx = 5,
}

/** 0 = Bticino 1 = Vantage */
export enum ExternalSensorType {
    Bticino = 0,
    Vantage = 1,
}

/** 0 = All 1 = Thermo 2 = Automation 3 = Energy 4 = Security 5 = Integration 6 = AllAndGateway 7 = OnlyGateway 8 = Nd 9 = NewChanges 10 = ID */
export enum FunctionType {
    All = 0,
    Thermo = 1,
    Automation = 2,
    Energy = 3,
    Security = 4,
    Integration = 5,
    AllAndGateway = 6,
    OnlyGateway = 7,
    Nd = 8,
    NewChanges = 9,
    ID = 10,
}

export class GeneralCommandsAndGroupsAction extends Action implements IGeneralCommandsAndGroupsAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    sceneShutterState?: SceneShutterState;
    sceneBlindState?: SceneBlindState;
    sceneSocketState?: SceneSocketState;

    constructor(data?: IGeneralCommandsAndGroupsAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkableObjectId = _data["linkableObjectId"];
            this.sceneLightState = _data["sceneLightState"];
            this.sceneShutterState = _data["sceneShutterState"];
            this.sceneBlindState = _data["sceneBlindState"];
            this.sceneSocketState = _data["sceneSocketState"];
        }
    }

    static fromJS(data: any): GeneralCommandsAndGroupsAction {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCommandsAndGroupsAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkableObjectId"] = this.linkableObjectId;
        data["sceneLightState"] = this.sceneLightState;
        data["sceneShutterState"] = this.sceneShutterState;
        data["sceneBlindState"] = this.sceneBlindState;
        data["sceneSocketState"] = this.sceneSocketState;
        super.toJSON(data);
        return data; 
    }
}

export interface IGeneralCommandsAndGroupsAction extends IAction {
    linkableObjectId?: string | undefined;
    sceneLightState?: SceneLightState;
    sceneShutterState?: SceneShutterState;
    sceneBlindState?: SceneBlindState;
    sceneSocketState?: SceneSocketState;
}

/** 0 = None 1 = OnOff 2 = Dimmer */
export enum LightType {
    None = 0,
    OnOff = 1,
    Dimmer = 2,
}

export class LightsActuatorItemSettingsDTO implements ILightsActuatorItemSettingsDTO {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelSelectedPickerValue?: SimpleIntPickerValue;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    isGroupZeroCrossingVisible?: boolean;
    isZeroCrossing1EnabledFollow2?: boolean;
    isZeroCrossing1DisabledFollow2?: boolean;
    isZeroCrossing2EnabledFollow1?: boolean;
    isZeroCrossing2DisabledFollow1?: boolean;
    isGroupRelayStatusAfterResetVisible?: boolean;
    isGroupRestoreStatusAfterResetVisible?: boolean;
    isGroupMinimumRegulationLevelVisible?: boolean;
    isGroupLoadTypeVisible?: boolean;
    hasLoadTypesForGroup7?: boolean;
    hasLoadTypesForGroup9?: boolean;
    isGroupVoltageVisible?: boolean;
    isGroupPULVisible?: boolean;
    saveTo?: number[] | undefined;
    minimumRegulationLevelPickerValues?: SimpleIntPickerValue[] | undefined;
    isGroupMinimumRegulationLevelToggleVisible?: boolean;
    isZeroCrossingWarningVisible?: boolean;

    constructor(data?: ILightsActuatorItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
            this.relayStatusAfterReset = _data["relayStatusAfterReset"];
            this.isRestoreStateAfterResetEnabled = _data["isRestoreStateAfterResetEnabled"];
            this.isMinimumregulationLevelEnabled = _data["isMinimumregulationLevelEnabled"];
            this.minimumRegulationLevelValue = _data["minimumRegulationLevelValue"];
            this.minimumRegulationLevelSelectedPickerValue = _data["minimumRegulationLevelSelectedPickerValue"] ? SimpleIntPickerValue.fromJS(_data["minimumRegulationLevelSelectedPickerValue"]) : <any>undefined;
            this.loadType = _data["loadType"];
            this.voltageType = _data["voltageType"];
            this.hasPUL = _data["hasPUL"];
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.isGroupZeroCrossingVisible = _data["isGroupZeroCrossingVisible"];
            this.isZeroCrossing1EnabledFollow2 = _data["isZeroCrossing1EnabledFollow2"];
            this.isZeroCrossing1DisabledFollow2 = _data["isZeroCrossing1DisabledFollow2"];
            this.isZeroCrossing2EnabledFollow1 = _data["isZeroCrossing2EnabledFollow1"];
            this.isZeroCrossing2DisabledFollow1 = _data["isZeroCrossing2DisabledFollow1"];
            this.isGroupRelayStatusAfterResetVisible = _data["isGroupRelayStatusAfterResetVisible"];
            this.isGroupRestoreStatusAfterResetVisible = _data["isGroupRestoreStatusAfterResetVisible"];
            this.isGroupMinimumRegulationLevelVisible = _data["isGroupMinimumRegulationLevelVisible"];
            this.isGroupLoadTypeVisible = _data["isGroupLoadTypeVisible"];
            this.hasLoadTypesForGroup7 = _data["hasLoadTypesForGroup7"];
            this.hasLoadTypesForGroup9 = _data["hasLoadTypesForGroup9"];
            this.isGroupVoltageVisible = _data["isGroupVoltageVisible"];
            this.isGroupPULVisible = _data["isGroupPULVisible"];
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            if (Array.isArray(_data["minimumRegulationLevelPickerValues"])) {
                this.minimumRegulationLevelPickerValues = [] as any;
                for (let item of _data["minimumRegulationLevelPickerValues"])
                    this.minimumRegulationLevelPickerValues!.push(SimpleIntPickerValue.fromJS(item));
            }
            this.isGroupMinimumRegulationLevelToggleVisible = _data["isGroupMinimumRegulationLevelToggleVisible"];
            this.isZeroCrossingWarningVisible = _data["isZeroCrossingWarningVisible"];
        }
    }

    static fromJS(data: any): LightsActuatorItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        data["relayStatusAfterReset"] = this.relayStatusAfterReset;
        data["isRestoreStateAfterResetEnabled"] = this.isRestoreStateAfterResetEnabled;
        data["isMinimumregulationLevelEnabled"] = this.isMinimumregulationLevelEnabled;
        data["minimumRegulationLevelValue"] = this.minimumRegulationLevelValue;
        data["minimumRegulationLevelSelectedPickerValue"] = this.minimumRegulationLevelSelectedPickerValue ? this.minimumRegulationLevelSelectedPickerValue.toJSON() : <any>undefined;
        data["loadType"] = this.loadType;
        data["voltageType"] = this.voltageType;
        data["hasPUL"] = this.hasPUL;
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["isGroupZeroCrossingVisible"] = this.isGroupZeroCrossingVisible;
        data["isZeroCrossing1EnabledFollow2"] = this.isZeroCrossing1EnabledFollow2;
        data["isZeroCrossing1DisabledFollow2"] = this.isZeroCrossing1DisabledFollow2;
        data["isZeroCrossing2EnabledFollow1"] = this.isZeroCrossing2EnabledFollow1;
        data["isZeroCrossing2DisabledFollow1"] = this.isZeroCrossing2DisabledFollow1;
        data["isGroupRelayStatusAfterResetVisible"] = this.isGroupRelayStatusAfterResetVisible;
        data["isGroupRestoreStatusAfterResetVisible"] = this.isGroupRestoreStatusAfterResetVisible;
        data["isGroupMinimumRegulationLevelVisible"] = this.isGroupMinimumRegulationLevelVisible;
        data["isGroupLoadTypeVisible"] = this.isGroupLoadTypeVisible;
        data["hasLoadTypesForGroup7"] = this.hasLoadTypesForGroup7;
        data["hasLoadTypesForGroup9"] = this.hasLoadTypesForGroup9;
        data["isGroupVoltageVisible"] = this.isGroupVoltageVisible;
        data["isGroupPULVisible"] = this.isGroupPULVisible;
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        if (Array.isArray(this.minimumRegulationLevelPickerValues)) {
            data["minimumRegulationLevelPickerValues"] = [];
            for (let item of this.minimumRegulationLevelPickerValues)
                data["minimumRegulationLevelPickerValues"].push(item.toJSON());
        }
        data["isGroupMinimumRegulationLevelToggleVisible"] = this.isGroupMinimumRegulationLevelToggleVisible;
        data["isZeroCrossingWarningVisible"] = this.isZeroCrossingWarningVisible;
        return data; 
    }
}

export interface ILightsActuatorItemSettingsDTO {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelSelectedPickerValue?: SimpleIntPickerValue;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    isGroupZeroCrossingVisible?: boolean;
    isZeroCrossing1EnabledFollow2?: boolean;
    isZeroCrossing1DisabledFollow2?: boolean;
    isZeroCrossing2EnabledFollow1?: boolean;
    isZeroCrossing2DisabledFollow1?: boolean;
    isGroupRelayStatusAfterResetVisible?: boolean;
    isGroupRestoreStatusAfterResetVisible?: boolean;
    isGroupMinimumRegulationLevelVisible?: boolean;
    isGroupLoadTypeVisible?: boolean;
    hasLoadTypesForGroup7?: boolean;
    hasLoadTypesForGroup9?: boolean;
    isGroupVoltageVisible?: boolean;
    isGroupPULVisible?: boolean;
    saveTo?: number[] | undefined;
    minimumRegulationLevelPickerValues?: SimpleIntPickerValue[] | undefined;
    isGroupMinimumRegulationLevelToggleVisible?: boolean;
    isZeroCrossingWarningVisible?: boolean;
}

export class LightsActuatorSettings extends ActuatorSettings implements ILightsActuatorSettings {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelValueAdvanced?: number;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;

    constructor(data?: ILightsActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
            this.relayStatusAfterReset = _data["relayStatusAfterReset"];
            this.isRestoreStateAfterResetEnabled = _data["isRestoreStateAfterResetEnabled"];
            this.isMinimumregulationLevelEnabled = _data["isMinimumregulationLevelEnabled"];
            this.minimumRegulationLevelValue = _data["minimumRegulationLevelValue"];
            this.minimumRegulationLevelValueAdvanced = _data["minimumRegulationLevelValueAdvanced"];
            this.loadType = _data["loadType"];
            this.voltageType = _data["voltageType"];
            this.hasPUL = _data["hasPUL"];
        }
    }

    static fromJS(data: any): LightsActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        data["relayStatusAfterReset"] = this.relayStatusAfterReset;
        data["isRestoreStateAfterResetEnabled"] = this.isRestoreStateAfterResetEnabled;
        data["isMinimumregulationLevelEnabled"] = this.isMinimumregulationLevelEnabled;
        data["minimumRegulationLevelValue"] = this.minimumRegulationLevelValue;
        data["minimumRegulationLevelValueAdvanced"] = this.minimumRegulationLevelValueAdvanced;
        data["loadType"] = this.loadType;
        data["voltageType"] = this.voltageType;
        data["hasPUL"] = this.hasPUL;
        super.toJSON(data);
        return data; 
    }
}

export interface ILightsActuatorSettings extends IActuatorSettings {
    isZeroCrossingEnabled?: boolean;
    relayStatusAfterReset?: RelayStatusAfterResetOptions;
    isRestoreStateAfterResetEnabled?: boolean;
    isMinimumregulationLevelEnabled?: boolean;
    minimumRegulationLevelValue?: number;
    minimumRegulationLevelValueAdvanced?: number;
    loadType?: LightsLoadTypes;
    voltageType?: LightsVoltageOptions;
    hasPUL?: boolean;
}

export class LightsActuatorSettingsObjectDTO implements ILightsActuatorSettingsObjectDTO {
    slots?: LightsActuatorItemSettingsDTO[] | undefined;

    constructor(data?: ILightsActuatorSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(LightsActuatorItemSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LightsActuatorSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsActuatorSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILightsActuatorSettingsObjectDTO {
    slots?: LightsActuatorItemSettingsDTO[] | undefined;
}

export class LightsCommandItemSettingsDTO implements ILightsCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    timedDelayPickerValues?: DelayValue[] | undefined;
    lightsOnOffMode?: LightsOnOffMode;
    minimumRegulationLevel?: number;
    timedDelayPickerSelectedValue?: DelayValue;
    isTimedDelayVisible?: boolean;
    defaultSettings?: LigthsCommandSettings;
    currentSettings?: LigthsCommandSettings;
    isOptionOnOffVisible?: boolean;
    isOptionOffVisible?: boolean;
    isOptionOnVisible?: boolean;
    isOptionOnRegulationVisible?: boolean;
    isOptionToggleVisible?: boolean;
    isOptionToggleOnOffVisible?: boolean;
    isOptionButtonVisible?: boolean;
    isOptionTimedVisible?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    availableDelayValues?: DelayValue[] | undefined;
    isContactTypeVisibile?: boolean;
    indexes?: number[] | undefined;
    conctactType?: ConctactType;
    isConctactTypeVisibile?: boolean;

    constructor(data?: ILightsCommandItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            if (Array.isArray(_data["timedDelayPickerValues"])) {
                this.timedDelayPickerValues = [] as any;
                for (let item of _data["timedDelayPickerValues"])
                    this.timedDelayPickerValues!.push(DelayValue.fromJS(item));
            }
            this.lightsOnOffMode = _data["lightsOnOffMode"];
            this.minimumRegulationLevel = _data["minimumRegulationLevel"];
            this.timedDelayPickerSelectedValue = _data["timedDelayPickerSelectedValue"] ? DelayValue.fromJS(_data["timedDelayPickerSelectedValue"]) : <any>undefined;
            this.isTimedDelayVisible = _data["isTimedDelayVisible"];
            this.defaultSettings = _data["defaultSettings"] ? LigthsCommandSettings.fromJS(_data["defaultSettings"]) : <any>undefined;
            this.currentSettings = _data["currentSettings"] ? LigthsCommandSettings.fromJS(_data["currentSettings"]) : <any>undefined;
            this.isOptionOnOffVisible = _data["isOptionOnOffVisible"];
            this.isOptionOffVisible = _data["isOptionOffVisible"];
            this.isOptionOnVisible = _data["isOptionOnVisible"];
            this.isOptionOnRegulationVisible = _data["isOptionOnRegulationVisible"];
            this.isOptionToggleVisible = _data["isOptionToggleVisible"];
            this.isOptionToggleOnOffVisible = _data["isOptionToggleOnOffVisible"];
            this.isOptionButtonVisible = _data["isOptionButtonVisible"];
            this.isOptionTimedVisible = _data["isOptionTimedVisible"];
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["availableDelayValues"])) {
                this.availableDelayValues = [] as any;
                for (let item of _data["availableDelayValues"])
                    this.availableDelayValues!.push(DelayValue.fromJS(item));
            }
            this.isContactTypeVisibile = _data["isContactTypeVisibile"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.conctactType = _data["conctactType"];
            this.isConctactTypeVisibile = _data["isConctactTypeVisibile"];
        }
    }

    static fromJS(data: any): LightsCommandItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsCommandItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        if (Array.isArray(this.timedDelayPickerValues)) {
            data["timedDelayPickerValues"] = [];
            for (let item of this.timedDelayPickerValues)
                data["timedDelayPickerValues"].push(item.toJSON());
        }
        data["lightsOnOffMode"] = this.lightsOnOffMode;
        data["minimumRegulationLevel"] = this.minimumRegulationLevel;
        data["timedDelayPickerSelectedValue"] = this.timedDelayPickerSelectedValue ? this.timedDelayPickerSelectedValue.toJSON() : <any>undefined;
        data["isTimedDelayVisible"] = this.isTimedDelayVisible;
        data["defaultSettings"] = this.defaultSettings ? this.defaultSettings.toJSON() : <any>undefined;
        data["currentSettings"] = this.currentSettings ? this.currentSettings.toJSON() : <any>undefined;
        data["isOptionOnOffVisible"] = this.isOptionOnOffVisible;
        data["isOptionOffVisible"] = this.isOptionOffVisible;
        data["isOptionOnVisible"] = this.isOptionOnVisible;
        data["isOptionOnRegulationVisible"] = this.isOptionOnRegulationVisible;
        data["isOptionToggleVisible"] = this.isOptionToggleVisible;
        data["isOptionToggleOnOffVisible"] = this.isOptionToggleOnOffVisible;
        data["isOptionButtonVisible"] = this.isOptionButtonVisible;
        data["isOptionTimedVisible"] = this.isOptionTimedVisible;
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.availableDelayValues)) {
            data["availableDelayValues"] = [];
            for (let item of this.availableDelayValues)
                data["availableDelayValues"].push(item.toJSON());
        }
        data["isContactTypeVisibile"] = this.isContactTypeVisibile;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["conctactType"] = this.conctactType;
        data["isConctactTypeVisibile"] = this.isConctactTypeVisibile;
        return data; 
    }
}

export interface ILightsCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    timedDelayPickerValues?: DelayValue[] | undefined;
    lightsOnOffMode?: LightsOnOffMode;
    minimumRegulationLevel?: number;
    timedDelayPickerSelectedValue?: DelayValue;
    isTimedDelayVisible?: boolean;
    defaultSettings?: LigthsCommandSettings;
    currentSettings?: LigthsCommandSettings;
    isOptionOnOffVisible?: boolean;
    isOptionOffVisible?: boolean;
    isOptionOnVisible?: boolean;
    isOptionOnRegulationVisible?: boolean;
    isOptionToggleVisible?: boolean;
    isOptionToggleOnOffVisible?: boolean;
    isOptionButtonVisible?: boolean;
    isOptionTimedVisible?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    availableDelayValues?: DelayValue[] | undefined;
    isContactTypeVisibile?: boolean;
    indexes?: number[] | undefined;
    conctactType?: ConctactType;
    isConctactTypeVisibile?: boolean;
}

export class LightsCommandSettingsObjectDTO implements ILightsCommandSettingsObjectDTO {
    slots?: LightsCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntentisy?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    readonly disabledModules?: boolean;

    constructor(data?: ILightsCommandSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(LightsCommandItemSettingsDTO.fromJS(item));
            }
            this.hasBrightness = _data["hasBrightness"];
            this.hasBrightness4Params = _data["hasBrightness4Params"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntentisy = _data["hasLedIntentisy"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
            this.hasSettings = _data["hasSettings"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            (<any>this).disabledModules = _data["disabledModules"];
        }
    }

    static fromJS(data: any): LightsCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightsCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["hasBrightness"] = this.hasBrightness;
        data["hasBrightness4Params"] = this.hasBrightness4Params;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntentisy"] = this.hasLedIntentisy;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        data["hasSettings"] = this.hasSettings;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["disabledModules"] = this.disabledModules;
        return data; 
    }
}

export interface ILightsCommandSettingsObjectDTO {
    slots?: LightsCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntentisy?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    disabledModules?: boolean;
}

/** 0 = Fluorescent 1 = Led 2 = Halogen 3 = LedTrailingEdgeOrElectronicTransformer 4 = LedLeadingEdge 5 = CFLTrailingEdge 6 = CFLLeadingEdge 7 = DaliStandard */
export enum LightsLoadTypes {
    Fluorescent = 0,
    Led = 1,
    Halogen = 2,
    LedTrailingEdgeOrElectronicTransformer = 3,
    LedLeadingEdge = 4,
    CFLTrailingEdge = 5,
    CFLLeadingEdge = 6,
    DaliStandard = 7,
}

/** 0 = Off 1 = OnOffRegulation 2 = Toggle 3 = Button 4 = Timed 5 = On 6 = OnRegulation 7 = ToggleOnOff 8 = CustomizedOn 9 = CustomizedOff 10 = CustomizedOnOff 11 = CustomizedOnOffRegulation 12 = CustomizedToggle 13 = CustomizedToggleRegulation 14 = CustomizedOnRegulation 15 = CustomizedOffRegulation */
export enum LightsOnOffMode {
    Off = 0,
    OnOffRegulation = 1,
    Toggle = 2,
    Button = 3,
    Timed = 4,
    On = 5,
    OnRegulation = 6,
    ToggleOnOff = 7,
    CustomizedOn = 8,
    CustomizedOff = 9,
    CustomizedOnOff = 10,
    CustomizedOnOffRegulation = 11,
    CustomizedToggle = 12,
    CustomizedToggleRegulation = 13,
    CustomizedOnRegulation = 14,
    CustomizedOffRegulation = 15,
}

/** 0 = AutoOnOff 1 = ManualOnAutoOff */
export enum LightsSensorOperatingMode {
    AutoOnOff = 0,
    ManualOnAutoOff = 1,
}

/** 0 = Low 1 = Medium 2 = High 3 = Maximum */
export enum LightsSensorSensitivity {
    Low = 0,
    Medium = 1,
    High = 2,
    Maximum = 3,
}

/** 0 = V_0_10 1 = V_1_10 */
export enum LightsVoltageOptions {
    V_0_10 = 0,
    V_1_10 = 1,
}

export class LigthsCommandSettings extends CommandSettings implements ILigthsCommandSettings {
    lightsOnOffMode?: LightsOnOffMode;
    lightsOnOffTimedDelay?: number;
    minimumRegulationLevel?: number;
    typeofContact?: ConctactType;
    powerON?: number;
    fadeIn?: number;
    fadeOut?: number;
    dimmingSpeed?: number;

    constructor(data?: ILigthsCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lightsOnOffMode = _data["lightsOnOffMode"];
            this.lightsOnOffTimedDelay = _data["lightsOnOffTimedDelay"];
            this.minimumRegulationLevel = _data["minimumRegulationLevel"];
            this.typeofContact = _data["typeofContact"];
            this.powerON = _data["powerON"];
            this.fadeIn = _data["fadeIn"];
            this.fadeOut = _data["fadeOut"];
            this.dimmingSpeed = _data["dimmingSpeed"];
        }
    }

    static fromJS(data: any): LigthsCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LigthsCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lightsOnOffMode"] = this.lightsOnOffMode;
        data["lightsOnOffTimedDelay"] = this.lightsOnOffTimedDelay;
        data["minimumRegulationLevel"] = this.minimumRegulationLevel;
        data["typeofContact"] = this.typeofContact;
        data["powerON"] = this.powerON;
        data["fadeIn"] = this.fadeIn;
        data["fadeOut"] = this.fadeOut;
        data["dimmingSpeed"] = this.dimmingSpeed;
        super.toJSON(data);
        return data; 
    }
}

export interface ILigthsCommandSettings extends ICommandSettings {
    lightsOnOffMode?: LightsOnOffMode;
    lightsOnOffTimedDelay?: number;
    minimumRegulationLevel?: number;
    typeofContact?: ConctactType;
    powerON?: number;
    fadeIn?: number;
    fadeOut?: number;
    dimmingSpeed?: number;
}

export class LigthsSensorCommandSettings extends CommandSettings implements ILigthsSensorCommandSettings {
    operationgfMode?: LightsSensorOperatingMode;
    daylightSetPoint?: number;
    timingOff?: number;
    pirSensitivity?: LightsSensorSensitivity;
    usSensitivity?: LightsSensorSensitivity;

    constructor(data?: ILigthsSensorCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operationgfMode = _data["operationgfMode"];
            this.daylightSetPoint = _data["daylightSetPoint"];
            this.timingOff = _data["timingOff"];
            this.pirSensitivity = _data["pirSensitivity"];
            this.usSensitivity = _data["usSensitivity"];
        }
    }

    static fromJS(data: any): LigthsSensorCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LigthsSensorCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationgfMode"] = this.operationgfMode;
        data["daylightSetPoint"] = this.daylightSetPoint;
        data["timingOff"] = this.timingOff;
        data["pirSensitivity"] = this.pirSensitivity;
        data["usSensitivity"] = this.usSensitivity;
        super.toJSON(data);
        return data; 
    }
}

export interface ILigthsSensorCommandSettings extends ICommandSettings {
    operationgfMode?: LightsSensorOperatingMode;
    daylightSetPoint?: number;
    timingOff?: number;
    pirSensitivity?: LightsSensorSensitivity;
    usSensitivity?: LightsSensorSensitivity;
}

/** 0 = None 1 = Partial 2 = Total */
export enum Line {
    None = 0,
    Partial = 1,
    Total = 2,
}

/** 0 = None 1 = Production 2 = Consumption */
export enum LineMisuration {
    None = 0,
    Production = 1,
    Consumption = 2,
}

export class LockActuatorSettings extends ActuatorSettings implements ILockActuatorSettings {
    isZeroCrossingEnabled?: boolean;

    constructor(data?: ILockActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
        }
    }

    static fromJS(data: any): LockActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LockActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        super.toJSON(data);
        return data; 
    }
}

export interface ILockActuatorSettings extends IActuatorSettings {
    isZeroCrossingEnabled?: boolean;
}

export class LockActuatorSettingsObjectParam implements ILockActuatorSettingsObjectParam {
    isZeroCrossingEnabled?: boolean;

    constructor(data?: ILockActuatorSettingsObjectParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isZeroCrossingEnabled = _data["isZeroCrossingEnabled"];
        }
    }

    static fromJS(data: any): LockActuatorSettingsObjectParam {
        data = typeof data === 'object' ? data : {};
        let result = new LockActuatorSettingsObjectParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isZeroCrossingEnabled"] = this.isZeroCrossingEnabled;
        return data; 
    }
}

export interface ILockActuatorSettingsObjectParam {
    isZeroCrossingEnabled?: boolean;
}

export class LockCommandSettings extends CommandSettings implements ILockCommandSettings {
    commandOpeningTime?: CommandOpeningTime;
    typeofContact?: ConctactType;
    scsLevel?: ScsLevel;

    constructor(data?: ILockCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.commandOpeningTime = _data["commandOpeningTime"];
            this.typeofContact = _data["typeofContact"];
            this.scsLevel = _data["scsLevel"];
        }
    }

    static fromJS(data: any): LockCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LockCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandOpeningTime"] = this.commandOpeningTime;
        data["typeofContact"] = this.typeofContact;
        data["scsLevel"] = this.scsLevel;
        super.toJSON(data);
        return data; 
    }
}

export interface ILockCommandSettings extends ICommandSettings {
    commandOpeningTime?: CommandOpeningTime;
    typeofContact?: ConctactType;
    scsLevel?: ScsLevel;
}

export class LockCommandSettingsObjectDTO implements ILockCommandSettingsObjectDTO {
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntentisy?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    slots?: LocksCommandItemSettingsDTO[] | undefined;
    isVde?: boolean;

    constructor(data?: ILockCommandSettingsObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBrightness = _data["hasBrightness"];
            this.hasBrightness4Params = _data["hasBrightness4Params"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntentisy = _data["hasLedIntentisy"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
            this.hasSettings = _data["hasSettings"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(LocksCommandItemSettingsDTO.fromJS(item));
            }
            this.isVde = _data["isVde"];
        }
    }

    static fromJS(data: any): LockCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LockCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBrightness"] = this.hasBrightness;
        data["hasBrightness4Params"] = this.hasBrightness4Params;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntentisy"] = this.hasLedIntentisy;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        data["hasSettings"] = this.hasSettings;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["isVde"] = this.isVde;
        return data; 
    }
}

export interface ILockCommandSettingsObjectDTO {
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntentisy?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    slots?: LocksCommandItemSettingsDTO[] | undefined;
    isVde?: boolean;
}

export class LocksCommandItemSettingsDTO implements ILocksCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    lightType?: LightType;
    isManagePosition?: boolean;
    isAppliedToAllSameTypeCommands?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    commandOpeningTime?: CommandOpeningTime;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    isVde?: boolean;
    scsLevel?: ScsLevel;

    constructor(data?: ILocksCommandItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.isAppliedToAllSameTypeCommands = _data["isAppliedToAllSameTypeCommands"];
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.commandOpeningTime = _data["commandOpeningTime"];
            this.isContactTypeVisibile = _data["isContactTypeVisibile"];
            this.conctactType = _data["conctactType"];
            this.isVde = _data["isVde"];
            this.scsLevel = _data["scsLevel"];
        }
    }

    static fromJS(data: any): LocksCommandItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocksCommandItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["isAppliedToAllSameTypeCommands"] = this.isAppliedToAllSameTypeCommands;
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["commandOpeningTime"] = this.commandOpeningTime;
        data["isContactTypeVisibile"] = this.isContactTypeVisibile;
        data["conctactType"] = this.conctactType;
        data["isVde"] = this.isVde;
        data["scsLevel"] = this.scsLevel;
        return data; 
    }
}

export interface ILocksCommandItemSettingsDTO {
    saveTo?: number[] | undefined;
    lightType?: LightType;
    isManagePosition?: boolean;
    isAppliedToAllSameTypeCommands?: boolean;
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    commandOpeningTime?: CommandOpeningTime;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    isVde?: boolean;
    scsLevel?: ScsLevel;
}

export class ObjectCondition extends Condition implements IObjectCondition {
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;

    constructor(data?: IObjectCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkableObjectId = _data["linkableObjectId"];
            this.stateComparer = _data["stateComparer"];
            this.lightState = _data["lightState"];
            this.dimmerState = _data["dimmerState"];
            this.dimmerPowerState = _data["dimmerPowerState"];
            this.dimmerPercent = _data["dimmerPercent"];
            this.workingMode = _data["workingMode"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.temperature = _data["temperature"];
            this.isShutterPositionManaged = _data["isShutterPositionManaged"];
            this.shutterModality = _data["shutterModality"];
            this.shutterState = _data["shutterState"];
            this.shutterPosition = _data["shutterPosition"];
            this.blindState = _data["blindState"];
            this.socketState = _data["socketState"];
            this.lockState = _data["lockState"];
            this.thermostatState = _data["thermostatState"];
            this.thermostatModalityState = _data["thermostatModalityState"];
            this.thermostatConditionState = _data["thermostatConditionState"];
            this.thermostatTemperature = _data["thermostatTemperature"];
            this.thermostatHumidity = _data["thermostatHumidity"];
            this.towelWarmerState = _data["towelWarmerState"];
            this.fancoilState = _data["fancoilState"];
            this.fancoilSpeedState = _data["fancoilSpeedState"];
            this.coloredLightsState = _data["coloredLightsState"];
            this.coloredLightStateComparer = _data["coloredLightStateComparer"];
            this.sceneColoredLightsColor = _data["sceneColoredLightsColor"];
            this.playerTriggerMode = _data["playerTriggerMode"];
            this.playerTriggerPowerState = _data["playerTriggerPowerState"];
            this.playerVolume = _data["playerVolume"];
            this.energyMeterKw = _data["energyMeterKw"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmSensorObjectStatus = _data["alarmSensorObjectStatus"];
            this.sceneLoadManagementStatus = _data["sceneLoadManagementStatus"];
            this.sceneLoadManagementPower = _data["sceneLoadManagementPower"];
        }
    }

    static fromJS(data: any): ObjectCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkableObjectId"] = this.linkableObjectId;
        data["stateComparer"] = this.stateComparer;
        data["lightState"] = this.lightState;
        data["dimmerState"] = this.dimmerState;
        data["dimmerPowerState"] = this.dimmerPowerState;
        data["dimmerPercent"] = this.dimmerPercent;
        data["workingMode"] = this.workingMode;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["temperature"] = this.temperature;
        data["isShutterPositionManaged"] = this.isShutterPositionManaged;
        data["shutterModality"] = this.shutterModality;
        data["shutterState"] = this.shutterState;
        data["shutterPosition"] = this.shutterPosition;
        data["blindState"] = this.blindState;
        data["socketState"] = this.socketState;
        data["lockState"] = this.lockState;
        data["thermostatState"] = this.thermostatState;
        data["thermostatModalityState"] = this.thermostatModalityState;
        data["thermostatConditionState"] = this.thermostatConditionState;
        data["thermostatTemperature"] = this.thermostatTemperature;
        data["thermostatHumidity"] = this.thermostatHumidity;
        data["towelWarmerState"] = this.towelWarmerState;
        data["fancoilState"] = this.fancoilState;
        data["fancoilSpeedState"] = this.fancoilSpeedState;
        data["coloredLightsState"] = this.coloredLightsState;
        data["coloredLightStateComparer"] = this.coloredLightStateComparer;
        data["sceneColoredLightsColor"] = this.sceneColoredLightsColor;
        data["playerTriggerMode"] = this.playerTriggerMode;
        data["playerTriggerPowerState"] = this.playerTriggerPowerState;
        data["playerVolume"] = this.playerVolume;
        data["energyMeterKw"] = this.energyMeterKw;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmSensorObjectStatus"] = this.alarmSensorObjectStatus;
        data["sceneLoadManagementStatus"] = this.sceneLoadManagementStatus;
        data["sceneLoadManagementPower"] = this.sceneLoadManagementPower;
        super.toJSON(data);
        return data; 
    }
}

export interface IObjectCondition extends ICondition {
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;
}

/** 0 = None 1 = NewDuplication 2 = OldDuplication */
export enum ObjectDuplication {
    None = 0,
    NewDuplication = 1,
    OldDuplication = 2,
}

export class ObjectTrigger extends Trigger implements IObjectTrigger {
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;

    constructor(data?: IObjectTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkableObjectId = _data["linkableObjectId"];
            this.stateComparer = _data["stateComparer"];
            this.lightState = _data["lightState"];
            this.dimmerState = _data["dimmerState"];
            this.dimmerPowerState = _data["dimmerPowerState"];
            this.dimmerPercent = _data["dimmerPercent"];
            this.workingMode = _data["workingMode"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.temperature = _data["temperature"];
            this.isShutterPositionManaged = _data["isShutterPositionManaged"];
            this.shutterModality = _data["shutterModality"];
            this.shutterState = _data["shutterState"];
            this.shutterPosition = _data["shutterPosition"];
            this.blindState = _data["blindState"];
            this.socketState = _data["socketState"];
            this.lockState = _data["lockState"];
            this.thermostatState = _data["thermostatState"];
            this.thermostatModalityState = _data["thermostatModalityState"];
            this.thermostatConditionState = _data["thermostatConditionState"];
            this.thermostatTemperature = _data["thermostatTemperature"];
            this.thermostatHumidity = _data["thermostatHumidity"];
            this.towelWarmerState = _data["towelWarmerState"];
            this.fancoilState = _data["fancoilState"];
            this.fancoilSpeedState = _data["fancoilSpeedState"];
            this.coloredLightsState = _data["coloredLightsState"];
            this.coloredLightStateComparer = _data["coloredLightStateComparer"];
            this.sceneColoredLightsColor = _data["sceneColoredLightsColor"];
            this.playerTriggerMode = _data["playerTriggerMode"];
            this.playerTriggerPowerState = _data["playerTriggerPowerState"];
            this.playerVolume = _data["playerVolume"];
            this.energyMeterKw = _data["energyMeterKw"];
            this.alarmPartitionState = _data["alarmPartitionState"];
            this.alarmSensorState = _data["alarmSensorState"];
            this.alarmSensorObjectStatus = _data["alarmSensorObjectStatus"];
            this.sceneLoadManagementStatus = _data["sceneLoadManagementStatus"];
            this.sceneLoadManagementPower = _data["sceneLoadManagementPower"];
        }
    }

    static fromJS(data: any): ObjectTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkableObjectId"] = this.linkableObjectId;
        data["stateComparer"] = this.stateComparer;
        data["lightState"] = this.lightState;
        data["dimmerState"] = this.dimmerState;
        data["dimmerPowerState"] = this.dimmerPowerState;
        data["dimmerPercent"] = this.dimmerPercent;
        data["workingMode"] = this.workingMode;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["temperature"] = this.temperature;
        data["isShutterPositionManaged"] = this.isShutterPositionManaged;
        data["shutterModality"] = this.shutterModality;
        data["shutterState"] = this.shutterState;
        data["shutterPosition"] = this.shutterPosition;
        data["blindState"] = this.blindState;
        data["socketState"] = this.socketState;
        data["lockState"] = this.lockState;
        data["thermostatState"] = this.thermostatState;
        data["thermostatModalityState"] = this.thermostatModalityState;
        data["thermostatConditionState"] = this.thermostatConditionState;
        data["thermostatTemperature"] = this.thermostatTemperature;
        data["thermostatHumidity"] = this.thermostatHumidity;
        data["towelWarmerState"] = this.towelWarmerState;
        data["fancoilState"] = this.fancoilState;
        data["fancoilSpeedState"] = this.fancoilSpeedState;
        data["coloredLightsState"] = this.coloredLightsState;
        data["coloredLightStateComparer"] = this.coloredLightStateComparer;
        data["sceneColoredLightsColor"] = this.sceneColoredLightsColor;
        data["playerTriggerMode"] = this.playerTriggerMode;
        data["playerTriggerPowerState"] = this.playerTriggerPowerState;
        data["playerVolume"] = this.playerVolume;
        data["energyMeterKw"] = this.energyMeterKw;
        data["alarmPartitionState"] = this.alarmPartitionState;
        data["alarmSensorState"] = this.alarmSensorState;
        data["alarmSensorObjectStatus"] = this.alarmSensorObjectStatus;
        data["sceneLoadManagementStatus"] = this.sceneLoadManagementStatus;
        data["sceneLoadManagementPower"] = this.sceneLoadManagementPower;
        super.toJSON(data);
        return data; 
    }
}

export interface IObjectTrigger extends ITrigger {
    linkableObjectId?: string | undefined;
    stateComparer?: SceneStateComparer;
    lightState?: SceneLightState;
    dimmerState?: SceneDimmerState;
    dimmerPowerState?: SceneDimmerPowerState;
    dimmerPercent?: number;
    workingMode?: DimmerWorkingMode;
    selectedColor?: Color;
    temperature?: number;
    isShutterPositionManaged?: boolean;
    shutterModality?: SceneShutterModality;
    shutterState?: SceneShutterState;
    shutterPosition?: number;
    blindState?: SceneBlindState;
    socketState?: SceneSocketState;
    lockState?: SceneLockState;
    thermostatState?: SceneThermostatState;
    thermostatModalityState?: SceneThermostatModalityState;
    thermostatConditionState?: SceneThermostatConditionState;
    thermostatTemperature?: number;
    thermostatHumidity?: number;
    towelWarmerState?: SceneTowelWarmerState;
    fancoilState?: SceneFancoilState;
    fancoilSpeedState?: SceneFancoilSpeedState;
    coloredLightsState?: SceneColoredLightsState;
    coloredLightStateComparer?: SceneStateComparer;
    sceneColoredLightsColor?: SceneColoredLightsColor;
    playerTriggerMode?: ScenePlayerTriggerMode;
    playerTriggerPowerState?: ScenePlayerState;
    playerVolume?: number;
    energyMeterKw?: number;
    alarmPartitionState?: AlarmPartitionState;
    alarmSensorState?: AlarmSensorStatus;
    alarmSensorObjectStatus?: AlarmSensorStatusScene;
    sceneLoadManagementStatus?: SceneLoadManagementState;
    sceneLoadManagementPower?: number | undefined;
}

export class ParamCreateLinkModule implements IParamCreateLinkModule {
    index?: number;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IParamCreateLinkModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ParamCreateLinkModule {
        data = typeof data === 'object' ? data : {};
        let result = new ParamCreateLinkModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IParamCreateLinkModule {
    index?: number;
    name?: string | undefined;
    value?: string | undefined;
}

export class ParamsScenesId implements IParamsScenesId {
    id?: string | undefined;
    button?: number;

    constructor(data?: IParamsScenesId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.button = _data["button"];
        }
    }

    static fromJS(data: any): ParamsScenesId {
        data = typeof data === 'object' ? data : {};
        let result = new ParamsScenesId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["button"] = this.button;
        return data; 
    }
}

export interface IParamsScenesId {
    id?: string | undefined;
    button?: number;
}

export class PlayerExtDevice extends ExtDevice implements IPlayerExtDevice {
    playerSystem?: PlayerSystem;
    readonly macAddress?: string | undefined;
    readonly name?: string | undefined;

    constructor(data?: IPlayerExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.playerSystem = _data["playerSystem"];
            (<any>this).macAddress = _data["macAddress"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): PlayerExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerSystem"] = this.playerSystem;
        data["macAddress"] = this.macAddress;
        data["name"] = this.name;
        super.toJSON(data);
        return data; 
    }
}

export interface IPlayerExtDevice extends IExtDevice {
    playerSystem?: PlayerSystem;
    macAddress?: string | undefined;
    name?: string | undefined;
}

/** 0 = Nuvo 1 = Sonos */
export enum PlayerSystem {
    Nuvo = 0,
    Sonos = 1,
}

export class ProbeSettings implements IProbeSettings {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;

    constructor(data?: IProbeSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLedmanaged = _data["isLedmanaged"];
            this.externalSensorType = _data["externalSensorType"];
        }
    }

    static fromJS(data: any): ProbeSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ProbeSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLedmanaged"] = this.isLedmanaged;
        data["externalSensorType"] = this.externalSensorType;
        return data; 
    }
}

export interface IProbeSettings {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;
}

/** 0 = None 1 = PhisicallyConfigured 2 = DeviceRemoved 3 = DeviceUnmanage 4 = DeviceChanged */
export enum ProblemType {
    None = 0,
    PhisicallyConfigured = 1,
    DeviceRemoved = 2,
    DeviceUnmanage = 3,
    DeviceChanged = 4,
}

export class PushNotificationAction extends Action implements IPushNotificationAction {

    constructor(data?: IPushNotificationAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PushNotificationAction {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IPushNotificationAction extends IAction {
}

/** 0 = LastStatus 1 = Opened 2 = Closed */
export enum RelayStatusAfterResetOptions {
    LastStatus = 0,
    Opened = 1,
    Closed = 2,
}

/** 0 = None 1 = Global 2 = Actuator */
export enum ResetType {
    None = 0,
    Global = 1,
    Actuator = 2,
}

export class Room implements IRoom {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObject[] | undefined;

    constructor(data?: IRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["roomObjects"])) {
                this.roomObjects = [] as any;
                for (let item of _data["roomObjects"])
                    this.roomObjects!.push(RoomObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Room {
        data = typeof data === 'object' ? data : {};
        let result = new Room();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.roomObjects)) {
            data["roomObjects"] = [];
            for (let item of this.roomObjects)
                data["roomObjects"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRoom {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObject[] | undefined;
}

export class RoomDTO implements IRoomDTO {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObjectDTO[] | undefined;

    constructor(data?: IRoomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["roomObjects"])) {
                this.roomObjects = [] as any;
                for (let item of _data["roomObjects"])
                    this.roomObjects!.push(RoomObjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.roomObjects)) {
            data["roomObjects"] = [];
            for (let item of this.roomObjects)
                data["roomObjects"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRoomDTO {
    id?: string | undefined;
    name?: string | undefined;
    type?: RoomType;
    roomObjects?: RoomObjectDTO[] | undefined;
}

export class RoomObject extends LinkableObject implements IRoomObject {
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    hasCommands?: boolean;
    roomId?: string | undefined;
    typeofProblem?: CompromisedType;
    lightType?: LightType;
    isManagePosition?: boolean;
    commandOpeningTime?: CommandOpeningTime;
    isAppliedToAllSameTypeCommands?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermo?: ThermoActuactor[] | undefined;
    isContactInError?: boolean;
    isTemperatureDisplayed?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    isInterlockSystemEnabled?: boolean;
    isSeasonModeAuto?: boolean;
    isSeasonChangeModifiable?: boolean;
    seasonChangeAutoType?: SeasonChangeAutoType;
    selected3477Device?: Device;
    seasonChangeAutoStartWinterDate?: Date;
    seasonChangeAutoStartSummerDate?: Date;
    isThermo99Zone?: boolean;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    heatingThermalProtection?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    temperatureType?: TemperatureType;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    isInterlockingExcluded?: boolean;
    pumpsDelay?: string;
    thermoUkFanSpeed?: number;
    thermoUkFanSpeed2?: number;
    thermoUkFanSpeed3?: number;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    address?: string | undefined;
    callType?: CallType;
    readonly isToChangeIntoID?: string | undefined;
    readonly isAddressConflict?: boolean;
    addressWithInterface?: string | undefined;
    pul?: boolean;
    readonly problemDescription?: string | undefined;

    constructor(data?: IRoomObject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.systemType = _data["systemType"];
            this.isHidden = _data["isHidden"];
            this.hasCommands = _data["hasCommands"];
            this.roomId = _data["roomId"];
            this.typeofProblem = _data["typeofProblem"];
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.commandOpeningTime = _data["commandOpeningTime"];
            this.isAppliedToAllSameTypeCommands = _data["isAppliedToAllSameTypeCommands"];
            this.energyMeterAndLoadControlType = _data["energyMeterAndLoadControlType"];
            this.isEnergyMeter = _data["isEnergyMeter"];
            this.toroidDirectionType = _data["toroidDirectionType"];
            this.tolerance = _data["tolerance"];
            this.priority = _data["priority"];
            this.supplyPower = _data["supplyPower"];
            this.lineType = _data["lineType"];
            this.lineMisurationType = _data["lineMisurationType"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
            this.actuatorModalityType = _data["actuatorModalityType"];
            this.coolingSystemControlType = _data["coolingSystemControlType"];
            this.heatingSystemControlType = _data["heatingSystemControlType"];
            this.sharedSystemControlType = _data["sharedSystemControlType"];
            if (Array.isArray(_data["thermo"])) {
                this.thermo = [] as any;
                for (let item of _data["thermo"])
                    this.thermo!.push(ThermoActuactor.fromJS(item));
            }
            this.isContactInError = _data["isContactInError"];
            this.isTemperatureDisplayed = _data["isTemperatureDisplayed"];
            this.isWaterCycleEnabled = _data["isWaterCycleEnabled"];
            this.arePumpsOpenedAutomatically = _data["arePumpsOpenedAutomatically"];
            this.minutesToKeepOpen = _data["minutesToKeepOpen"];
            this.openAutomaticallyDaysDelay = _data["openAutomaticallyDaysDelay"];
            this.isInterlockSystemEnabled = _data["isInterlockSystemEnabled"];
            this.isSeasonModeAuto = _data["isSeasonModeAuto"];
            this.isSeasonChangeModifiable = _data["isSeasonChangeModifiable"];
            this.seasonChangeAutoType = _data["seasonChangeAutoType"];
            this.selected3477Device = _data["selected3477Device"] ? Device.fromJS(_data["selected3477Device"]) : <any>undefined;
            this.seasonChangeAutoStartWinterDate = _data["seasonChangeAutoStartWinterDate"] ? new Date(_data["seasonChangeAutoStartWinterDate"].toString()) : <any>undefined;
            this.seasonChangeAutoStartSummerDate = _data["seasonChangeAutoStartSummerDate"] ? new Date(_data["seasonChangeAutoStartSummerDate"].toString()) : <any>undefined;
            this.isThermo99Zone = _data["isThermo99Zone"];
            this.thermo99SelectedZone = _data["thermo99SelectedZone"];
            this.thermo99HasFancoil = _data["thermo99HasFancoil"];
            this.heatingSetpointLow = _data["heatingSetpointLow"];
            this.heatingSetpointHigh = _data["heatingSetpointHigh"];
            this.heatingAntifreeze = _data["heatingAntifreeze"];
            this.heatingThermalProtection = _data["heatingThermalProtection"];
            this.coolingSetpointLow = _data["coolingSetpointLow"];
            this.coolingSetpointHigh = _data["coolingSetpointHigh"];
            this.coolingThermalProtection = _data["coolingThermalProtection"];
            this.isAutoCommutation = _data["isAutoCommutation"];
            this.delayHeatingPumps = _data["delayHeatingPumps"];
            this.delayCoolingPumps = _data["delayCoolingPumps"];
            this.temperatureType = _data["temperatureType"];
            this.areButtonsEnabled = _data["areButtonsEnabled"];
            this.externalSensorType = _data["externalSensorType"];
            this.isBacklightEnabled = _data["isBacklightEnabled"];
            this.backlightLevel = _data["backlightLevel"];
            this.isManualHeatingOverrideEnabled = _data["isManualHeatingOverrideEnabled"];
            this.heatingRegulationBand = _data["heatingRegulationBand"];
            this.fanSpeed2ForHeating = _data["fanSpeed2ForHeating"];
            this.fanSpeed3ForHeating = _data["fanSpeed3ForHeating"];
            this.valvesTimeForHeatingFanCoil = _data["valvesTimeForHeatingFanCoil"];
            this.isManualCoolingOverrideEnabled = _data["isManualCoolingOverrideEnabled"];
            this.coolingRegulationBand = _data["coolingRegulationBand"];
            this.fanSpeed2ForCooling = _data["fanSpeed2ForCooling"];
            this.fanSpeed3ForCooling = _data["fanSpeed3ForCooling"];
            this.valvesTimeForCoolingFanCoil = _data["valvesTimeForCoolingFanCoil"];
            this.isIconAlwaysOff = _data["isIconAlwaysOff"];
            this.isLocalContactNumberEnabled = _data["isLocalContactNumberEnabled"];
            this.numberOfWindowsContact = _data["numberOfWindowsContact"];
            this.openingContactTypeHeating = _data["openingContactTypeHeating"];
            this.openingContactTempHeating = _data["openingContactTempHeating"];
            this.openingContactDelayHeating = _data["openingContactDelayHeating"];
            this.timeoutOpeningHeating = _data["timeoutOpeningHeating"];
            this.closingContactTypeHeating = _data["closingContactTypeHeating"];
            this.closingContactTempHeating = _data["closingContactTempHeating"];
            this.closingContactDelayHeating = _data["closingContactDelayHeating"];
            this.timeoutClosingHeating = _data["timeoutClosingHeating"];
            this.openingContactTypeCooling = _data["openingContactTypeCooling"];
            this.openingContactTempCooling = _data["openingContactTempCooling"];
            this.openingContactDelayCooling = _data["openingContactDelayCooling"];
            this.timeoutOpeningCooling = _data["timeoutOpeningCooling"];
            this.closingContactTypeCooling = _data["closingContactTypeCooling"];
            this.closingContactTempCooling = _data["closingContactTempCooling"];
            this.closingContactDelayCooling = _data["closingContactDelayCooling"];
            this.timeoutClosingCooling = _data["timeoutClosingCooling"];
            this.isCoolingVentilationEnabled = _data["isCoolingVentilationEnabled"];
            this.isHeatingVentilationEnabled = _data["isHeatingVentilationEnabled"];
            this.timeoutCoolingVentilation = _data["timeoutCoolingVentilation"];
            this.timeoutHeatingVentilation = _data["timeoutHeatingVentilation"];
            this.isInterlockingExcluded = _data["isInterlockingExcluded"];
            this.pumpsDelay = _data["pumpsDelay"];
            this.thermoUkFanSpeed = _data["thermoUkFanSpeed"];
            this.thermoUkFanSpeed2 = _data["thermoUkFanSpeed2"];
            this.thermoUkFanSpeed3 = _data["thermoUkFanSpeed3"];
            this.coloredLightType = _data["coloredLightType"];
            this.daliType = _data["daliType"];
            this.isColor = _data["isColor"];
            this.isTemperatureColor = _data["isTemperatureColor"];
            this.address = _data["address"];
            this.callType = _data["callType"];
            (<any>this).isToChangeIntoID = _data["isToChangeIntoID"];
            (<any>this).isAddressConflict = _data["isAddressConflict"];
            this.addressWithInterface = _data["addressWithInterface"];
            this.pul = _data["pul"];
            (<any>this).problemDescription = _data["problemDescription"];
        }
    }

    static fromJS(data: any): RoomObject {
        data = typeof data === 'object' ? data : {};
        let result = new RoomObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["systemType"] = this.systemType;
        data["isHidden"] = this.isHidden;
        data["hasCommands"] = this.hasCommands;
        data["roomId"] = this.roomId;
        data["typeofProblem"] = this.typeofProblem;
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["commandOpeningTime"] = this.commandOpeningTime;
        data["isAppliedToAllSameTypeCommands"] = this.isAppliedToAllSameTypeCommands;
        data["energyMeterAndLoadControlType"] = this.energyMeterAndLoadControlType;
        data["isEnergyMeter"] = this.isEnergyMeter;
        data["toroidDirectionType"] = this.toroidDirectionType;
        data["tolerance"] = this.tolerance;
        data["priority"] = this.priority;
        data["supplyPower"] = this.supplyPower;
        data["lineType"] = this.lineType;
        data["lineMisurationType"] = this.lineMisurationType;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        data["actuatorModalityType"] = this.actuatorModalityType;
        data["coolingSystemControlType"] = this.coolingSystemControlType;
        data["heatingSystemControlType"] = this.heatingSystemControlType;
        data["sharedSystemControlType"] = this.sharedSystemControlType;
        if (Array.isArray(this.thermo)) {
            data["thermo"] = [];
            for (let item of this.thermo)
                data["thermo"].push(item.toJSON());
        }
        data["isContactInError"] = this.isContactInError;
        data["isTemperatureDisplayed"] = this.isTemperatureDisplayed;
        data["isWaterCycleEnabled"] = this.isWaterCycleEnabled;
        data["arePumpsOpenedAutomatically"] = this.arePumpsOpenedAutomatically;
        data["minutesToKeepOpen"] = this.minutesToKeepOpen;
        data["openAutomaticallyDaysDelay"] = this.openAutomaticallyDaysDelay;
        data["isInterlockSystemEnabled"] = this.isInterlockSystemEnabled;
        data["isSeasonModeAuto"] = this.isSeasonModeAuto;
        data["isSeasonChangeModifiable"] = this.isSeasonChangeModifiable;
        data["seasonChangeAutoType"] = this.seasonChangeAutoType;
        data["selected3477Device"] = this.selected3477Device ? this.selected3477Device.toJSON() : <any>undefined;
        data["seasonChangeAutoStartWinterDate"] = this.seasonChangeAutoStartWinterDate ? this.seasonChangeAutoStartWinterDate.toISOString() : <any>undefined;
        data["seasonChangeAutoStartSummerDate"] = this.seasonChangeAutoStartSummerDate ? this.seasonChangeAutoStartSummerDate.toISOString() : <any>undefined;
        data["isThermo99Zone"] = this.isThermo99Zone;
        data["thermo99SelectedZone"] = this.thermo99SelectedZone;
        data["thermo99HasFancoil"] = this.thermo99HasFancoil;
        data["heatingSetpointLow"] = this.heatingSetpointLow;
        data["heatingSetpointHigh"] = this.heatingSetpointHigh;
        data["heatingAntifreeze"] = this.heatingAntifreeze;
        data["heatingThermalProtection"] = this.heatingThermalProtection;
        data["coolingSetpointLow"] = this.coolingSetpointLow;
        data["coolingSetpointHigh"] = this.coolingSetpointHigh;
        data["coolingThermalProtection"] = this.coolingThermalProtection;
        data["isAutoCommutation"] = this.isAutoCommutation;
        data["delayHeatingPumps"] = this.delayHeatingPumps;
        data["delayCoolingPumps"] = this.delayCoolingPumps;
        data["temperatureType"] = this.temperatureType;
        data["areButtonsEnabled"] = this.areButtonsEnabled;
        data["externalSensorType"] = this.externalSensorType;
        data["isBacklightEnabled"] = this.isBacklightEnabled;
        data["backlightLevel"] = this.backlightLevel;
        data["isManualHeatingOverrideEnabled"] = this.isManualHeatingOverrideEnabled;
        data["heatingRegulationBand"] = this.heatingRegulationBand;
        data["fanSpeed2ForHeating"] = this.fanSpeed2ForHeating;
        data["fanSpeed3ForHeating"] = this.fanSpeed3ForHeating;
        data["valvesTimeForHeatingFanCoil"] = this.valvesTimeForHeatingFanCoil;
        data["isManualCoolingOverrideEnabled"] = this.isManualCoolingOverrideEnabled;
        data["coolingRegulationBand"] = this.coolingRegulationBand;
        data["fanSpeed2ForCooling"] = this.fanSpeed2ForCooling;
        data["fanSpeed3ForCooling"] = this.fanSpeed3ForCooling;
        data["valvesTimeForCoolingFanCoil"] = this.valvesTimeForCoolingFanCoil;
        data["isIconAlwaysOff"] = this.isIconAlwaysOff;
        data["isLocalContactNumberEnabled"] = this.isLocalContactNumberEnabled;
        data["numberOfWindowsContact"] = this.numberOfWindowsContact;
        data["openingContactTypeHeating"] = this.openingContactTypeHeating;
        data["openingContactTempHeating"] = this.openingContactTempHeating;
        data["openingContactDelayHeating"] = this.openingContactDelayHeating;
        data["timeoutOpeningHeating"] = this.timeoutOpeningHeating;
        data["closingContactTypeHeating"] = this.closingContactTypeHeating;
        data["closingContactTempHeating"] = this.closingContactTempHeating;
        data["closingContactDelayHeating"] = this.closingContactDelayHeating;
        data["timeoutClosingHeating"] = this.timeoutClosingHeating;
        data["openingContactTypeCooling"] = this.openingContactTypeCooling;
        data["openingContactTempCooling"] = this.openingContactTempCooling;
        data["openingContactDelayCooling"] = this.openingContactDelayCooling;
        data["timeoutOpeningCooling"] = this.timeoutOpeningCooling;
        data["closingContactTypeCooling"] = this.closingContactTypeCooling;
        data["closingContactTempCooling"] = this.closingContactTempCooling;
        data["closingContactDelayCooling"] = this.closingContactDelayCooling;
        data["timeoutClosingCooling"] = this.timeoutClosingCooling;
        data["isCoolingVentilationEnabled"] = this.isCoolingVentilationEnabled;
        data["isHeatingVentilationEnabled"] = this.isHeatingVentilationEnabled;
        data["timeoutCoolingVentilation"] = this.timeoutCoolingVentilation;
        data["timeoutHeatingVentilation"] = this.timeoutHeatingVentilation;
        data["isInterlockingExcluded"] = this.isInterlockingExcluded;
        data["pumpsDelay"] = this.pumpsDelay;
        data["thermoUkFanSpeed"] = this.thermoUkFanSpeed;
        data["thermoUkFanSpeed2"] = this.thermoUkFanSpeed2;
        data["thermoUkFanSpeed3"] = this.thermoUkFanSpeed3;
        data["coloredLightType"] = this.coloredLightType;
        data["daliType"] = this.daliType;
        data["isColor"] = this.isColor;
        data["isTemperatureColor"] = this.isTemperatureColor;
        data["address"] = this.address;
        data["callType"] = this.callType;
        data["isToChangeIntoID"] = this.isToChangeIntoID;
        data["isAddressConflict"] = this.isAddressConflict;
        data["addressWithInterface"] = this.addressWithInterface;
        data["pul"] = this.pul;
        data["problemDescription"] = this.problemDescription;
        super.toJSON(data);
        return data; 
    }
}

export interface IRoomObject extends ILinkableObject {
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    hasCommands?: boolean;
    roomId?: string | undefined;
    typeofProblem?: CompromisedType;
    lightType?: LightType;
    isManagePosition?: boolean;
    commandOpeningTime?: CommandOpeningTime;
    isAppliedToAllSameTypeCommands?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    coolingSystemControlType?: SystemControlType;
    heatingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    thermo?: ThermoActuactor[] | undefined;
    isContactInError?: boolean;
    isTemperatureDisplayed?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    isInterlockSystemEnabled?: boolean;
    isSeasonModeAuto?: boolean;
    isSeasonChangeModifiable?: boolean;
    seasonChangeAutoType?: SeasonChangeAutoType;
    selected3477Device?: Device;
    seasonChangeAutoStartWinterDate?: Date;
    seasonChangeAutoStartSummerDate?: Date;
    isThermo99Zone?: boolean;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    heatingThermalProtection?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    temperatureType?: TemperatureType;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    isInterlockingExcluded?: boolean;
    pumpsDelay?: string;
    thermoUkFanSpeed?: number;
    thermoUkFanSpeed2?: number;
    thermoUkFanSpeed3?: number;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    address?: string | undefined;
    callType?: CallType;
    isToChangeIntoID?: string | undefined;
    isAddressConflict?: boolean;
    addressWithInterface?: string | undefined;
    pul?: boolean;
    problemDescription?: string | undefined;
}

export class RoomObjectDTO implements IRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    hasConfigurationToEnd?: boolean;
    extDevices?: ExtDevice[] | undefined;

    constructor(data?: IRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            this.type = _data["type"];
            this.systemType = _data["systemType"];
            this.isHidden = _data["isHidden"];
            this.lightType = _data["lightType"];
            this.isManagePosition = _data["isManagePosition"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
            this.thermo99SelectedZone = _data["thermo99SelectedZone"];
            this.thermo99HasFancoil = _data["thermo99HasFancoil"];
            this.energyMeterAndLoadControlType = _data["energyMeterAndLoadControlType"];
            this.isEnergyMeter = _data["isEnergyMeter"];
            this.toroidDirectionType = _data["toroidDirectionType"];
            this.tolerance = _data["tolerance"];
            this.priority = _data["priority"];
            this.supplyPower = _data["supplyPower"];
            this.lineType = _data["lineType"];
            this.lineMisurationType = _data["lineMisurationType"];
            this.coloredLightType = _data["coloredLightType"];
            this.daliType = _data["daliType"];
            this.isColor = _data["isColor"];
            this.isTemperatureColor = _data["isTemperatureColor"];
            this.hasConfigurationToEnd = _data["hasConfigurationToEnd"];
            if (Array.isArray(_data["extDevices"])) {
                this.extDevices = [] as any;
                for (let item of _data["extDevices"])
                    this.extDevices!.push(ExtDevice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["systemType"] = this.systemType;
        data["isHidden"] = this.isHidden;
        data["lightType"] = this.lightType;
        data["isManagePosition"] = this.isManagePosition;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        data["thermo99SelectedZone"] = this.thermo99SelectedZone;
        data["thermo99HasFancoil"] = this.thermo99HasFancoil;
        data["energyMeterAndLoadControlType"] = this.energyMeterAndLoadControlType;
        data["isEnergyMeter"] = this.isEnergyMeter;
        data["toroidDirectionType"] = this.toroidDirectionType;
        data["tolerance"] = this.tolerance;
        data["priority"] = this.priority;
        data["supplyPower"] = this.supplyPower;
        data["lineType"] = this.lineType;
        data["lineMisurationType"] = this.lineMisurationType;
        data["coloredLightType"] = this.coloredLightType;
        data["daliType"] = this.daliType;
        data["isColor"] = this.isColor;
        data["isTemperatureColor"] = this.isTemperatureColor;
        data["hasConfigurationToEnd"] = this.hasConfigurationToEnd;
        if (Array.isArray(this.extDevices)) {
            data["extDevices"] = [];
            for (let item of this.extDevices)
                data["extDevices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    systemType?: SystemType;
    isHidden?: boolean;
    lightType?: LightType;
    isManagePosition?: boolean;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    thermo99SelectedZone?: string | undefined;
    thermo99HasFancoil?: boolean;
    energyMeterAndLoadControlType?: EnergyMeterAndLoadControlType;
    isEnergyMeter?: boolean;
    toroidDirectionType?: ToroidDirection;
    tolerance?: string | undefined;
    priority?: number;
    supplyPower?: string | undefined;
    lineType?: Line;
    lineMisurationType?: LineMisuration;
    coloredLightType?: ColoredLightType;
    daliType?: DaliType;
    isColor?: boolean;
    isTemperatureColor?: boolean;
    hasConfigurationToEnd?: boolean;
    extDevices?: ExtDevice[] | undefined;
}

/** 0 = Light 1 = Shutter 2 = Socket 3 = Lock 4 = Thermostat 5 = Fancoil 6 = TowelWarmer 7 = WirelessCommand 8 = Blind 9 = Player 10 = Xmeter 11 = Alarm 12 = ColoredLight 13 = ScheduledScenarioPlus 14 = None 15 = Contact 16 = AlarmSensor 17 = Thermostat99zones 18 = DimmerDmx 19 = DimmerDali 20 = Actuactor 21 = CentralLoadControl 22 = ActuactorLoadControl 23 = VdeLock 24 = StaircaseLight 25 = FloorCall 26 = Unknown */
export enum RoomObjectType {
    Light = 0,
    Shutter = 1,
    Socket = 2,
    Lock = 3,
    Thermostat = 4,
    Fancoil = 5,
    TowelWarmer = 6,
    WirelessCommand = 7,
    Blind = 8,
    Player = 9,
    Xmeter = 10,
    Alarm = 11,
    ColoredLight = 12,
    ScheduledScenarioPlus = 13,
    None = 14,
    Contact = 15,
    AlarmSensor = 16,
    Thermostat99zones = 17,
    DimmerDmx = 18,
    DimmerDali = 19,
    Actuactor = 20,
    CentralLoadControl = 21,
    ActuactorLoadControl = 22,
    VdeLock = 23,
    StaircaseLight = 24,
    FloorCall = 25,
    Unknown = 26,
}

/** 0 = Livingroom 1 = Bathroom 2 = Kitchen 3 = Bedroom 4 = Dining_room 5 = Toilets 6 = Lobby 7 = Corridor 8 = Garage 9 = Outdoor 10 = Home_office 11 = Stairs 12 = Electrical_cabinet 13 = Custom 14 = Unknown */
export enum RoomType {
    Livingroom = 0,
    Bathroom = 1,
    Kitchen = 2,
    Bedroom = 3,
    Dining_room = 4,
    Toilets = 5,
    Lobby = 6,
    Corridor = 7,
    Garage = 8,
    Outdoor = 9,
    Home_office = 10,
    Stairs = 11,
    Electrical_cabinet = 12,
    Custom = 13,
    Unknown = 14,
}

export class Scene extends LinkableObject implements IScene {
    type?: SceneType;
    isDisabled?: boolean;
    isHidden?: boolean;
    isEditable?: boolean;
    isSceneFromServer?: boolean;
    actions?: Action[] | undefined;
    triggers?: Trigger[] | undefined;
    conditions?: Condition[] | undefined;
    room_id?: string | undefined;
    share?: boolean;
    user?: string | undefined;
    category?: string | undefined;
    preconditionSelected?: SceneThermostatModalityState;
    isColorChanged?: boolean;
    has_Button_Trigger?: boolean | undefined;
    typeofProblem?: CompromisedType;

    constructor(data?: IScene) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.isDisabled = _data["isDisabled"];
            this.isHidden = _data["isHidden"];
            this.isEditable = _data["isEditable"];
            this.isSceneFromServer = _data["isSceneFromServer"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(Action.fromJS(item));
            }
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers!.push(Trigger.fromJS(item));
            }
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(Condition.fromJS(item));
            }
            this.room_id = _data["room_id"];
            this.share = _data["share"];
            this.user = _data["user"];
            this.category = _data["category"];
            this.preconditionSelected = _data["preconditionSelected"];
            this.isColorChanged = _data["isColorChanged"];
            this.has_Button_Trigger = _data["has_Button_Trigger"];
            this.typeofProblem = _data["typeofProblem"];
        }
    }

    static fromJS(data: any): Scene {
        data = typeof data === 'object' ? data : {};
        let result = new Scene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["isDisabled"] = this.isDisabled;
        data["isHidden"] = this.isHidden;
        data["isEditable"] = this.isEditable;
        data["isSceneFromServer"] = this.isSceneFromServer;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item.toJSON());
        }
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        data["room_id"] = this.room_id;
        data["share"] = this.share;
        data["user"] = this.user;
        data["category"] = this.category;
        data["preconditionSelected"] = this.preconditionSelected;
        data["isColorChanged"] = this.isColorChanged;
        data["has_Button_Trigger"] = this.has_Button_Trigger;
        data["typeofProblem"] = this.typeofProblem;
        super.toJSON(data);
        return data; 
    }
}

export interface IScene extends ILinkableObject {
    type?: SceneType;
    isDisabled?: boolean;
    isHidden?: boolean;
    isEditable?: boolean;
    isSceneFromServer?: boolean;
    actions?: Action[] | undefined;
    triggers?: Trigger[] | undefined;
    conditions?: Condition[] | undefined;
    room_id?: string | undefined;
    share?: boolean;
    user?: string | undefined;
    category?: string | undefined;
    preconditionSelected?: SceneThermostatModalityState;
    isColorChanged?: boolean;
    has_Button_Trigger?: boolean | undefined;
    typeofProblem?: CompromisedType;
}

/** 0 = None 1 = Open 2 = Close */
export enum SceneBlindState {
    None = 0,
    Open = 1,
    Close = 2,
}

/** 0 = Blue 1 = LightPurple 2 = Magenta 3 = Fuchsia 4 = Red 5 = Orange 6 = Yellow 7 = Lime 8 = Green 9 = AcquaGreen 10 = LightBlue 11 = LightBlueSky */
export enum SceneColoredLightsColor {
    Blue = 0,
    LightPurple = 1,
    Magenta = 2,
    Fuchsia = 3,
    Red = 4,
    Orange = 5,
    Yellow = 6,
    Lime = 7,
    Green = 8,
    AcquaGreen = 9,
    LightBlue = 10,
    LightBlueSky = 11,
}

/** 0 = None 1 = On 2 = Off */
export enum SceneColoredLightsState {
    None = 0,
    On = 1,
    Off = 2,
}

/** 0 = None 1 = On 2 = Off */
export enum SceneDimmerPowerState {
    None = 0,
    On = 1,
    Off = 2,
}

/** 0 = None 1 = Dimmer 2 = Power */
export enum SceneDimmerState {
    None = 0,
    Dimmer = 1,
    Power = 2,
}

/** 0 = None 1 = One 2 = Two 3 = Three */
export enum SceneFancoilSpeedState {
    None = 0,
    One = 1,
    Two = 2,
    Three = 3,
}

/** 0 = Off 1 = On 2 = None */
export enum SceneFancoilState {
    Off = 0,
    On = 1,
    None = 2,
}

/** 0 = None 1 = On 2 = Off */
export enum SceneLightState {
    None = 0,
    On = 1,
    Off = 2,
}

/** 0 = None 1 = On 2 = Off 3 = Force 4 = Shedded 5 = Power 6 = UnForce */
export enum SceneLoadManagementState {
    None = 0,
    On = 1,
    Off = 2,
    Force = 3,
    Shedded = 4,
    Power = 5,
    UnForce = 6,
}

/** 0 = None 1 = On */
export enum SceneLockState {
    None = 0,
    On = 1,
}

/** 0 = None 1 = Stop 2 = Play 3 = Pause */
export enum ScenePlayerState {
    None = 0,
    Stop = 1,
    Play = 2,
    Pause = 3,
}

/** 0 = None 1 = Power 2 = Volume */
export enum ScenePlayerTriggerMode {
    None = 0,
    Power = 1,
    Volume = 2,
}

/** 0 = None 1 = Movement 2 = Position */
export enum SceneShutterModality {
    None = 0,
    Movement = 1,
    Position = 2,
}

/** 0 = None 1 = Up 2 = Stop 3 = Down */
export enum SceneShutterState {
    None = 0,
    Up = 1,
    Stop = 2,
    Down = 3,
}

/** 0 = None 1 = On 2 = Off */
export enum SceneSocketState {
    None = 0,
    On = 1,
    Off = 2,
}

/** 0 = None 1 = Equal 2 = Different 3 = Higher 4 = Lower 5 = Any */
export enum SceneStateComparer {
    None = 0,
    Equal = 1,
    Different = 2,
    Higher = 3,
    Lower = 4,
    Any = 5,
}

/** 0 = Off 1 = On 2 = None */
export enum SceneThermostatConditionState {
    Off = 0,
    On = 1,
    None = 2,
}

/** 0 = None 1 = Heating 2 = Cooling 3 = Auto 5 = Off */
export enum SceneThermostatModalityState {
    None = 0,
    Heating = 1,
    Cooling = 2,
    Auto = 3,
    Off = 5,
}

/** 0 = None 1 = Modality 2 = Temperature 3 = DesiredTemperature 4 = Condition 5 = Humidity */
export enum SceneThermostatState {
    None = 0,
    Modality = 1,
    Temperature = 2,
    DesiredTemperature = 3,
    Condition = 4,
    Humidity = 5,
}

/** 0 = Off 1 = On 2 = None */
export enum SceneTowelWarmerState {
    Off = 0,
    On = 1,
    None = 2,
}

/** 0 = Wake_Up 1 = BedTime 2 = Home 3 = Away 4 = Custom */
export enum SceneType {
    Wake_Up = 0,
    BedTime = 1,
    Home = 2,
    Away = 3,
    Custom = 4,
}

/** 0 = None 1 = Sunrise 2 = Sunset */
export enum SceneWeatherCrepuscular {
    None = 0,
    Sunrise = 1,
    Sunset = 2,
}

/** 0 = None 1 = Sunny 2 = Rain 3 = Storm 4 = Cloudy 5 = Snow 6 = Foggy */
export enum SceneWeatherForecastState {
    None = 0,
    Sunny = 1,
    Rain = 2,
    Storm = 3,
    Cloudy = 4,
    Snow = 5,
    Foggy = 6,
}

/** 0 = None 1 = Temperature 2 = Wind 3 = Humidity 4 = WeatherForecast 5 = Crepuscular */
export enum SceneWeatherModality {
    None = 0,
    Temperature = 1,
    Wind = 2,
    Humidity = 3,
    WeatherForecast = 4,
    Crepuscular = 5,
}

/** 0 = Samelevel 1 = Riser 2 = Building 3 = Backbone */
export enum ScsLevel {
    Samelevel = 0,
    Riser = 1,
    Building = 2,
    Backbone = 3,
}

/** 0 = None 1 = WithDate 2 = WithDevice 3 = WithTemperature */
export enum SeasonChangeAutoType {
    None = 0,
    WithDate = 1,
    WithDevice = 2,
    WithTemperature = 3,
}

export class SelectColorAction extends Action implements ISelectColorAction {
    hasTemperature?: boolean;
    hasColor?: boolean;
    name?: string | undefined;
    selectedColor?: Color;
    workingMode?: DimmerWorkingMode;
    temperature?: number;

    constructor(data?: ISelectColorAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasTemperature = _data["hasTemperature"];
            this.hasColor = _data["hasColor"];
            this.name = _data["name"];
            this.selectedColor = _data["selectedColor"] ? Color.fromJS(_data["selectedColor"]) : <any>undefined;
            this.workingMode = _data["workingMode"];
            this.temperature = _data["temperature"];
        }
    }

    static fromJS(data: any): SelectColorAction {
        data = typeof data === 'object' ? data : {};
        let result = new SelectColorAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTemperature"] = this.hasTemperature;
        data["hasColor"] = this.hasColor;
        data["name"] = this.name;
        data["selectedColor"] = this.selectedColor ? this.selectedColor.toJSON() : <any>undefined;
        data["workingMode"] = this.workingMode;
        data["temperature"] = this.temperature;
        super.toJSON(data);
        return data; 
    }
}

export interface ISelectColorAction extends IAction {
    hasTemperature?: boolean;
    hasColor?: boolean;
    name?: string | undefined;
    selectedColor?: Color;
    workingMode?: DimmerWorkingMode;
    temperature?: number;
}

export class ShutterActuatorSettings extends ActuatorSettings implements IShutterActuatorSettings {
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;

    constructor(data?: IShutterActuatorSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasPUL = _data["hasPUL"];
            this.shutterMotorType = _data["shutterMotorType"];
            this.shutterMode = _data["shutterMode"];
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.stopPulseDuration = _data["stopPulseDuration"];
            this.upDownPulseDuration = _data["upDownPulseDuration"];
            this.stopTime = _data["stopTime"];
            this.delayBetweenDoorsTime = _data["delayBetweenDoorsTime"];
        }
    }

    static fromJS(data: any): ShutterActuatorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterActuatorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPUL"] = this.hasPUL;
        data["shutterMotorType"] = this.shutterMotorType;
        data["shutterMode"] = this.shutterMode;
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["stopPulseDuration"] = this.stopPulseDuration;
        data["upDownPulseDuration"] = this.upDownPulseDuration;
        data["stopTime"] = this.stopTime;
        data["delayBetweenDoorsTime"] = this.delayBetweenDoorsTime;
        super.toJSON(data);
        return data; 
    }
}

export interface IShutterActuatorSettings extends IActuatorSettings {
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
}

export class ShutterCommandItemSettingsDTO implements IShutterCommandItemSettingsDTO {
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    presetValue?: number;
    shutterMode?: ShutterMode;
    commandDirection?: CommandDirection;
    hasPreset?: boolean;
    isManagedPosition?: boolean;
    saveTo?: number[] | undefined;
    showBistableAndBladesControl?: boolean;
    showMonostableAndBistable?: boolean;
    showBladesControlAndBistable?: boolean;
    showPreset?: boolean;
    showCommandDirection?: boolean;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;

    constructor(data?: IShutterCommandItemSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasMoreThanOneSlotSettings = _data["hasMoreThanOneSlotSettings"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [] as any;
                for (let item of _data["indexes"])
                    this.indexes!.push(item);
            }
            this.presetValue = _data["presetValue"];
            this.shutterMode = _data["shutterMode"];
            this.commandDirection = _data["commandDirection"];
            this.hasPreset = _data["hasPreset"];
            this.isManagedPosition = _data["isManagedPosition"];
            if (Array.isArray(_data["saveTo"])) {
                this.saveTo = [] as any;
                for (let item of _data["saveTo"])
                    this.saveTo!.push(item);
            }
            this.showBistableAndBladesControl = _data["showBistableAndBladesControl"];
            this.showMonostableAndBistable = _data["showMonostableAndBistable"];
            this.showBladesControlAndBistable = _data["showBladesControlAndBistable"];
            this.showPreset = _data["showPreset"];
            this.showCommandDirection = _data["showCommandDirection"];
            this.isContactTypeVisibile = _data["isContactTypeVisibile"];
            this.conctactType = _data["conctactType"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
            this.hasChanges = _data["hasChanges"];
        }
    }

    static fromJS(data: any): ShutterCommandItemSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterCommandItemSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasMoreThanOneSlotSettings"] = this.hasMoreThanOneSlotSettings;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["presetValue"] = this.presetValue;
        data["shutterMode"] = this.shutterMode;
        data["commandDirection"] = this.commandDirection;
        data["hasPreset"] = this.hasPreset;
        data["isManagedPosition"] = this.isManagedPosition;
        if (Array.isArray(this.saveTo)) {
            data["saveTo"] = [];
            for (let item of this.saveTo)
                data["saveTo"].push(item);
        }
        data["showBistableAndBladesControl"] = this.showBistableAndBladesControl;
        data["showMonostableAndBistable"] = this.showMonostableAndBistable;
        data["showBladesControlAndBistable"] = this.showBladesControlAndBistable;
        data["showPreset"] = this.showPreset;
        data["showCommandDirection"] = this.showCommandDirection;
        data["isContactTypeVisibile"] = this.isContactTypeVisibile;
        data["conctactType"] = this.conctactType;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        data["hasChanges"] = this.hasChanges;
        return data; 
    }
}

export interface IShutterCommandItemSettingsDTO {
    hasMoreThanOneSlotSettings?: boolean;
    indexes?: number[] | undefined;
    presetValue?: number;
    shutterMode?: ShutterMode;
    commandDirection?: CommandDirection;
    hasPreset?: boolean;
    isManagedPosition?: boolean;
    saveTo?: number[] | undefined;
    showBistableAndBladesControl?: boolean;
    showMonostableAndBistable?: boolean;
    showBladesControlAndBistable?: boolean;
    showPreset?: boolean;
    showCommandDirection?: boolean;
    isContactTypeVisibile?: boolean;
    conctactType?: ConctactType;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
    hasChanges?: boolean;
}

export class ShutterCommandSettings extends CommandSettings implements IShutterCommandSettings {
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    commandDirection?: CommandDirection;
    typeofContact?: ConctactType;

    constructor(data?: IShutterCommandSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shutterMode = _data["shutterMode"];
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.commandDirection = _data["commandDirection"];
            this.typeofContact = _data["typeofContact"];
        }
    }

    static fromJS(data: any): ShutterCommandSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ShutterCommandSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shutterMode"] = this.shutterMode;
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["commandDirection"] = this.commandDirection;
        data["typeofContact"] = this.typeofContact;
        super.toJSON(data);
        return data; 
    }
}

export interface IShutterCommandSettings extends ICommandSettings {
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    commandDirection?: CommandDirection;
    typeofContact?: ConctactType;
}

/** 0 = Monostable 1 = Bistable 2 = BistableWithBladesControl 3 = BladesAndBistable 4 = MonostableBistable */
export enum ShutterMode {
    Monostable = 0,
    Bistable = 1,
    BistableWithBladesControl = 2,
    BladesAndBistable = 3,
    MonostableBistable = 4,
}

/** 0 = StandardAutomatic 1 = Standard 2 = Pulse */
export enum ShutterMotorType {
    StandardAutomatic = 0,
    Standard = 1,
    Pulse = 2,
}

export class ShuttersActuatorSettingsObjectParam implements IShuttersActuatorSettingsObjectParam {
    isManagedPosition?: boolean;
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    isGroupPULVisible?: boolean;
    isGroupMotorTypeVisible?: boolean;
    canHaveStandardAutomaticMotorType?: boolean;
    isGroupModeVisible?: boolean;
    isGroupPresetVisible?: boolean;
    isGroupStopTimeTypeVisible?: boolean;
    isGroupDelayBetweenDoorsVisible?: boolean;
    stopPulseDurationPickerValues?: DelayValue[] | undefined;
    upDownPulseDurationPickerValues?: DelayValue[] | undefined;
    stopTimePickerValues?: DelayValue[] | undefined;
    delayBetweenDoorsTimePickerValues?: DelayValue[] | undefined;

    constructor(data?: IShuttersActuatorSettingsObjectParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isManagedPosition = _data["isManagedPosition"];
            this.hasPUL = _data["hasPUL"];
            this.shutterMotorType = _data["shutterMotorType"];
            this.stopPulseDuration = _data["stopPulseDuration"];
            this.upDownPulseDuration = _data["upDownPulseDuration"];
            this.shutterMode = _data["shutterMode"];
            this.hasPreset = _data["hasPreset"];
            this.presetValue = _data["presetValue"];
            this.stopTime = _data["stopTime"];
            this.delayBetweenDoorsTime = _data["delayBetweenDoorsTime"];
            this.isGroupPULVisible = _data["isGroupPULVisible"];
            this.isGroupMotorTypeVisible = _data["isGroupMotorTypeVisible"];
            this.canHaveStandardAutomaticMotorType = _data["canHaveStandardAutomaticMotorType"];
            this.isGroupModeVisible = _data["isGroupModeVisible"];
            this.isGroupPresetVisible = _data["isGroupPresetVisible"];
            this.isGroupStopTimeTypeVisible = _data["isGroupStopTimeTypeVisible"];
            this.isGroupDelayBetweenDoorsVisible = _data["isGroupDelayBetweenDoorsVisible"];
            if (Array.isArray(_data["stopPulseDurationPickerValues"])) {
                this.stopPulseDurationPickerValues = [] as any;
                for (let item of _data["stopPulseDurationPickerValues"])
                    this.stopPulseDurationPickerValues!.push(DelayValue.fromJS(item));
            }
            if (Array.isArray(_data["upDownPulseDurationPickerValues"])) {
                this.upDownPulseDurationPickerValues = [] as any;
                for (let item of _data["upDownPulseDurationPickerValues"])
                    this.upDownPulseDurationPickerValues!.push(DelayValue.fromJS(item));
            }
            if (Array.isArray(_data["stopTimePickerValues"])) {
                this.stopTimePickerValues = [] as any;
                for (let item of _data["stopTimePickerValues"])
                    this.stopTimePickerValues!.push(DelayValue.fromJS(item));
            }
            if (Array.isArray(_data["delayBetweenDoorsTimePickerValues"])) {
                this.delayBetweenDoorsTimePickerValues = [] as any;
                for (let item of _data["delayBetweenDoorsTimePickerValues"])
                    this.delayBetweenDoorsTimePickerValues!.push(DelayValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShuttersActuatorSettingsObjectParam {
        data = typeof data === 'object' ? data : {};
        let result = new ShuttersActuatorSettingsObjectParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isManagedPosition"] = this.isManagedPosition;
        data["hasPUL"] = this.hasPUL;
        data["shutterMotorType"] = this.shutterMotorType;
        data["stopPulseDuration"] = this.stopPulseDuration;
        data["upDownPulseDuration"] = this.upDownPulseDuration;
        data["shutterMode"] = this.shutterMode;
        data["hasPreset"] = this.hasPreset;
        data["presetValue"] = this.presetValue;
        data["stopTime"] = this.stopTime;
        data["delayBetweenDoorsTime"] = this.delayBetweenDoorsTime;
        data["isGroupPULVisible"] = this.isGroupPULVisible;
        data["isGroupMotorTypeVisible"] = this.isGroupMotorTypeVisible;
        data["canHaveStandardAutomaticMotorType"] = this.canHaveStandardAutomaticMotorType;
        data["isGroupModeVisible"] = this.isGroupModeVisible;
        data["isGroupPresetVisible"] = this.isGroupPresetVisible;
        data["isGroupStopTimeTypeVisible"] = this.isGroupStopTimeTypeVisible;
        data["isGroupDelayBetweenDoorsVisible"] = this.isGroupDelayBetweenDoorsVisible;
        if (Array.isArray(this.stopPulseDurationPickerValues)) {
            data["stopPulseDurationPickerValues"] = [];
            for (let item of this.stopPulseDurationPickerValues)
                data["stopPulseDurationPickerValues"].push(item.toJSON());
        }
        if (Array.isArray(this.upDownPulseDurationPickerValues)) {
            data["upDownPulseDurationPickerValues"] = [];
            for (let item of this.upDownPulseDurationPickerValues)
                data["upDownPulseDurationPickerValues"].push(item.toJSON());
        }
        if (Array.isArray(this.stopTimePickerValues)) {
            data["stopTimePickerValues"] = [];
            for (let item of this.stopTimePickerValues)
                data["stopTimePickerValues"].push(item.toJSON());
        }
        if (Array.isArray(this.delayBetweenDoorsTimePickerValues)) {
            data["delayBetweenDoorsTimePickerValues"] = [];
            for (let item of this.delayBetweenDoorsTimePickerValues)
                data["delayBetweenDoorsTimePickerValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShuttersActuatorSettingsObjectParam {
    isManagedPosition?: boolean;
    hasPUL?: boolean;
    shutterMotorType?: ShutterMotorType;
    stopPulseDuration?: number;
    upDownPulseDuration?: number;
    shutterMode?: ShutterMode;
    hasPreset?: boolean;
    presetValue?: number;
    stopTime?: number;
    delayBetweenDoorsTime?: number;
    isGroupPULVisible?: boolean;
    isGroupMotorTypeVisible?: boolean;
    canHaveStandardAutomaticMotorType?: boolean;
    isGroupModeVisible?: boolean;
    isGroupPresetVisible?: boolean;
    isGroupStopTimeTypeVisible?: boolean;
    isGroupDelayBetweenDoorsVisible?: boolean;
    stopPulseDurationPickerValues?: DelayValue[] | undefined;
    upDownPulseDurationPickerValues?: DelayValue[] | undefined;
    stopTimePickerValues?: DelayValue[] | undefined;
    delayBetweenDoorsTimePickerValues?: DelayValue[] | undefined;
}

export class ShuttersCommandSettingsObjectDTO extends BaseShuttersCommandSettingsObjectDTO implements IShuttersCommandSettingsObjectDTO {
    slots?: ShutterCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntentisy?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;

    constructor(data?: IShuttersCommandSettingsObjectDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(ShutterCommandItemSettingsDTO.fromJS(item));
            }
            this.hasBrightness = _data["hasBrightness"];
            this.hasBrightness4Params = _data["hasBrightness4Params"];
            this.hasProximity = _data["hasProximity"];
            this.hasStandby = _data["hasStandby"];
            this.hasLedIntentisy = _data["hasLedIntentisy"];
            this.hasLedModality = _data["hasLedModality"];
            this.hasRefreshFeedback = _data["hasRefreshFeedback"];
            this.hasSettings = _data["hasSettings"];
            this.deviceBrightness = _data["deviceBrightness"];
            this.showLedsInStandby = _data["showLedsInStandby"];
            this.isProximityEnabled = _data["isProximityEnabled"];
            this.deviceProximity = _data["deviceProximity"];
            this.ledIntensity = _data["ledIntensity"];
            this.ledModality = _data["ledModality"];
            this.deviceIconsVisibility = _data["deviceIconsVisibility"];
        }
    }

    static fromJS(data: any): ShuttersCommandSettingsObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShuttersCommandSettingsObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        data["hasBrightness"] = this.hasBrightness;
        data["hasBrightness4Params"] = this.hasBrightness4Params;
        data["hasProximity"] = this.hasProximity;
        data["hasStandby"] = this.hasStandby;
        data["hasLedIntentisy"] = this.hasLedIntentisy;
        data["hasLedModality"] = this.hasLedModality;
        data["hasRefreshFeedback"] = this.hasRefreshFeedback;
        data["hasSettings"] = this.hasSettings;
        data["deviceBrightness"] = this.deviceBrightness;
        data["showLedsInStandby"] = this.showLedsInStandby;
        data["isProximityEnabled"] = this.isProximityEnabled;
        data["deviceProximity"] = this.deviceProximity;
        data["ledIntensity"] = this.ledIntensity;
        data["ledModality"] = this.ledModality;
        data["deviceIconsVisibility"] = this.deviceIconsVisibility;
        super.toJSON(data);
        return data; 
    }
}

export interface IShuttersCommandSettingsObjectDTO extends IBaseShuttersCommandSettingsObjectDTO {
    slots?: ShutterCommandItemSettingsDTO[] | undefined;
    hasBrightness?: boolean;
    hasBrightness4Params?: boolean;
    hasProximity?: boolean;
    hasStandby?: boolean;
    hasLedIntentisy?: boolean;
    hasLedModality?: boolean;
    hasRefreshFeedback?: boolean;
    hasSettings?: boolean;
    deviceBrightness?: DeviceBrightness;
    showLedsInStandby?: boolean;
    isProximityEnabled?: boolean;
    deviceProximity?: DeviceProximity;
    ledIntensity?: number;
    ledModality?: DeviceLedModality;
    deviceIconsVisibility?: DeviceIconsVisibility;
}

export class SimpleIntPickerValue implements ISimpleIntPickerValue {
    value?: number;
    readonly description?: string | undefined;

    constructor(data?: ISimpleIntPickerValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            (<any>this).description = _data["description"];
        }
    }

    static fromJS(data: any): SimpleIntPickerValue {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleIntPickerValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        return data; 
    }
}

export interface ISimpleIntPickerValue {
    value?: number;
    description?: string | undefined;
}

export class Slot implements ISlot {
    configured?: boolean;
    id?: string | undefined;
    keyObject?: number;
    links_id?: string[] | undefined;
    groups_id?: string[] | undefined;
    index?: number;
    address?: string | undefined;
    status?: SlotStatus;
    linkedObjects?: LinkableObject[] | undefined;
    configurationType?: ConfigurationType;
    modalityTypeConfiguration?: ActuatorModalityType;
    thermoActuatorTypes?: { [key: string]: ThermoActuatorType; } | undefined;
    assignedComponentType?: ComponentType;
    isSetting?: boolean;
    commandIcon?: CommandIcon;
    paramsKo?: ParamCreateLinkModule[] | undefined;
    scenes_id?: ParamsScenesId[] | undefined;
    commandSettings?: CommandSettings | undefined;
    probeSettings?: ProbeSettings;
    actuatorSettings?: ActuatorSettings | undefined;
    isShutterSelfCommandActuatorSlot?: boolean;
    mX_Id_ThermoCU?: string | undefined;
    destinationLevel?: number;
    indexFather?: number;
    overWrite?: boolean;
    blockOverwiteEnabled?: boolean;

    constructor(data?: ISlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configured = _data["configured"];
            this.id = _data["id"];
            this.keyObject = _data["keyObject"];
            if (Array.isArray(_data["links_id"])) {
                this.links_id = [] as any;
                for (let item of _data["links_id"])
                    this.links_id!.push(item);
            }
            if (Array.isArray(_data["groups_id"])) {
                this.groups_id = [] as any;
                for (let item of _data["groups_id"])
                    this.groups_id!.push(item);
            }
            this.index = _data["index"];
            this.address = _data["address"];
            this.status = _data["status"];
            if (Array.isArray(_data["linkedObjects"])) {
                this.linkedObjects = [] as any;
                for (let item of _data["linkedObjects"])
                    this.linkedObjects!.push(LinkableObject.fromJS(item));
            }
            this.configurationType = _data["configurationType"];
            this.modalityTypeConfiguration = _data["modalityTypeConfiguration"];
            if (_data["thermoActuatorTypes"]) {
                this.thermoActuatorTypes = {} as any;
                for (let key in _data["thermoActuatorTypes"]) {
                    if (_data["thermoActuatorTypes"].hasOwnProperty(key))
                        (<any>this.thermoActuatorTypes)![key] = _data["thermoActuatorTypes"][key];
                }
            }
            this.assignedComponentType = _data["assignedComponentType"];
            this.isSetting = _data["isSetting"];
            this.commandIcon = _data["commandIcon"];
            if (Array.isArray(_data["paramsKo"])) {
                this.paramsKo = [] as any;
                for (let item of _data["paramsKo"])
                    this.paramsKo!.push(ParamCreateLinkModule.fromJS(item));
            }
            if (Array.isArray(_data["scenes_id"])) {
                this.scenes_id = [] as any;
                for (let item of _data["scenes_id"])
                    this.scenes_id!.push(ParamsScenesId.fromJS(item));
            }
            this.commandSettings = _data["commandSettings"] ? CommandSettings.fromJS(_data["commandSettings"]) : <any>undefined;
            this.probeSettings = _data["probeSettings"] ? ProbeSettings.fromJS(_data["probeSettings"]) : <any>undefined;
            this.actuatorSettings = _data["actuatorSettings"] ? ActuatorSettings.fromJS(_data["actuatorSettings"]) : <any>undefined;
            this.isShutterSelfCommandActuatorSlot = _data["isShutterSelfCommandActuatorSlot"];
            this.mX_Id_ThermoCU = _data["mX_Id_ThermoCU"];
            this.destinationLevel = _data["destinationLevel"];
            this.indexFather = _data["indexFather"];
            this.overWrite = _data["overWrite"];
            this.blockOverwiteEnabled = _data["blockOverwiteEnabled"];
        }
    }

    static fromJS(data: any): Slot {
        data = typeof data === 'object' ? data : {};
        let result = new Slot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configured"] = this.configured;
        data["id"] = this.id;
        data["keyObject"] = this.keyObject;
        if (Array.isArray(this.links_id)) {
            data["links_id"] = [];
            for (let item of this.links_id)
                data["links_id"].push(item);
        }
        if (Array.isArray(this.groups_id)) {
            data["groups_id"] = [];
            for (let item of this.groups_id)
                data["groups_id"].push(item);
        }
        data["index"] = this.index;
        data["address"] = this.address;
        data["status"] = this.status;
        if (Array.isArray(this.linkedObjects)) {
            data["linkedObjects"] = [];
            for (let item of this.linkedObjects)
                data["linkedObjects"].push(item.toJSON());
        }
        data["configurationType"] = this.configurationType;
        data["modalityTypeConfiguration"] = this.modalityTypeConfiguration;
        if (this.thermoActuatorTypes) {
            data["thermoActuatorTypes"] = {};
            for (let key in this.thermoActuatorTypes) {
                if (this.thermoActuatorTypes.hasOwnProperty(key))
                    (<any>data["thermoActuatorTypes"])[key] = this.thermoActuatorTypes[key];
            }
        }
        data["assignedComponentType"] = this.assignedComponentType;
        data["isSetting"] = this.isSetting;
        data["commandIcon"] = this.commandIcon;
        if (Array.isArray(this.paramsKo)) {
            data["paramsKo"] = [];
            for (let item of this.paramsKo)
                data["paramsKo"].push(item.toJSON());
        }
        if (Array.isArray(this.scenes_id)) {
            data["scenes_id"] = [];
            for (let item of this.scenes_id)
                data["scenes_id"].push(item.toJSON());
        }
        data["commandSettings"] = this.commandSettings ? this.commandSettings.toJSON() : <any>undefined;
        data["probeSettings"] = this.probeSettings ? this.probeSettings.toJSON() : <any>undefined;
        data["actuatorSettings"] = this.actuatorSettings ? this.actuatorSettings.toJSON() : <any>undefined;
        data["isShutterSelfCommandActuatorSlot"] = this.isShutterSelfCommandActuatorSlot;
        data["mX_Id_ThermoCU"] = this.mX_Id_ThermoCU;
        data["destinationLevel"] = this.destinationLevel;
        data["indexFather"] = this.indexFather;
        data["overWrite"] = this.overWrite;
        data["blockOverwiteEnabled"] = this.blockOverwiteEnabled;
        return data; 
    }
}

export interface ISlot {
    configured?: boolean;
    id?: string | undefined;
    keyObject?: number;
    links_id?: string[] | undefined;
    groups_id?: string[] | undefined;
    index?: number;
    address?: string | undefined;
    status?: SlotStatus;
    linkedObjects?: LinkableObject[] | undefined;
    configurationType?: ConfigurationType;
    modalityTypeConfiguration?: ActuatorModalityType;
    thermoActuatorTypes?: { [key: string]: ThermoActuatorType; } | undefined;
    assignedComponentType?: ComponentType;
    isSetting?: boolean;
    commandIcon?: CommandIcon;
    paramsKo?: ParamCreateLinkModule[] | undefined;
    scenes_id?: ParamsScenesId[] | undefined;
    commandSettings?: CommandSettings | undefined;
    probeSettings?: ProbeSettings;
    actuatorSettings?: ActuatorSettings | undefined;
    isShutterSelfCommandActuatorSlot?: boolean;
    mX_Id_ThermoCU?: string | undefined;
    destinationLevel?: number;
    indexFather?: number;
    overWrite?: boolean;
    blockOverwiteEnabled?: boolean;
}

/** 0 = Configured 1 = NotConfigured 2 = NotUsed 3 = MarkedForLinking 4 = MarkedAdjacent 5 = NoLoad 6 = NoCompatible */
export enum SlotStatus {
    Configured = 0,
    NotConfigured = 1,
    NotUsed = 2,
    MarkedForLinking = 3,
    MarkedAdjacent = 4,
    NoLoad = 5,
    NoCompatible = 6,
}

/** 0 = None 1 = OneOnOffValve 2 = OneOpenCloseValve 3 = OneProportionalValve 4 = TwoTubesOnOffValve 5 = TwoTubesProportionalValve 6 = TwoTubesProportionalSpeedControlValve 7 = FourTubesOnOffValve 8 = FourTubesProportionalValve 9 = FourTubesProportionalSpeedControlValve 10 = GatewayMode 11 = Pump */
export enum SystemControlType {
    None = 0,
    OneOnOffValve = 1,
    OneOpenCloseValve = 2,
    OneProportionalValve = 3,
    TwoTubesOnOffValve = 4,
    TwoTubesProportionalValve = 5,
    TwoTubesProportionalSpeedControlValve = 6,
    FourTubesOnOffValve = 7,
    FourTubesProportionalValve = 8,
    FourTubesProportionalSpeedControlValve = 9,
    GatewayMode = 10,
    Pump = 11,
}

/** 0 = Scs 1 = Zigbee */
export enum SystemType {
    Scs = 0,
    Zigbee = 1,
}

/** 0 = Celsius 1 = Fahrenheit */
export enum TemperatureType {
    Celsius = 0,
    Fahrenheit = 1,
}

export class ThermoActuactor implements IThermoActuactor {
    number?: number;
    function?: ThermoActuatorType;
    valve?: boolean;
    id?: string[] | undefined;

    constructor(data?: IThermoActuactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.function = _data["function"];
            this.valve = _data["valve"];
            if (Array.isArray(_data["id"])) {
                this.id = [] as any;
                for (let item of _data["id"])
                    this.id!.push(item);
            }
        }
    }

    static fromJS(data: any): ThermoActuactor {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoActuactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["function"] = this.function;
        data["valve"] = this.valve;
        if (Array.isArray(this.id)) {
            data["id"] = [];
            for (let item of this.id)
                data["id"].push(item);
        }
        return data; 
    }
}

export interface IThermoActuactor {
    number?: number;
    function?: ThermoActuatorType;
    valve?: boolean;
    id?: string[] | undefined;
}

/** 0 = None 1 = HeatingValve 2 = HeatingPump 3 = CoolingValve 4 = CoolingPump 5 = SharedValve 6 = SharedPump 7 = HeatingAndCoolingPump 8 = HeatingAndCoolingValve */
export enum ThermoActuatorType {
    None = 0,
    HeatingValve = 1,
    HeatingPump = 2,
    CoolingValve = 3,
    CoolingPump = 4,
    SharedValve = 5,
    SharedPump = 6,
    HeatingAndCoolingPump = 7,
    HeatingAndCoolingValve = 8,
}

/** 0 = None 1 = Yes 2 = No */
export enum ThermoAssociatedPump {
    None = 0,
    Yes = 1,
    No = 2,
}

export class ThermoOldInformation implements IThermoOldInformation {
    address?: string | undefined;
    links_id?: string[] | undefined;

    constructor(data?: IThermoOldInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            if (Array.isArray(_data["links_id"])) {
                this.links_id = [] as any;
                for (let item of _data["links_id"])
                    this.links_id!.push(item);
            }
        }
    }

    static fromJS(data: any): ThermoOldInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoOldInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        if (Array.isArray(this.links_id)) {
            data["links_id"] = [];
            for (let item of this.links_id)
                data["links_id"].push(item);
        }
        return data; 
    }
}

export interface IThermoOldInformation {
    address?: string | undefined;
    links_id?: string[] | undefined;
}

export class ThermoProbeSettingsObjectParam implements IThermoProbeSettingsObjectParam {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;
    isLedmanagedVisible?: boolean;
    isExternalSensorTypeVisible?: boolean;

    constructor(data?: IThermoProbeSettingsObjectParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLedmanaged = _data["isLedmanaged"];
            this.externalSensorType = _data["externalSensorType"];
            this.isLedmanagedVisible = _data["isLedmanagedVisible"];
            this.isExternalSensorTypeVisible = _data["isExternalSensorTypeVisible"];
        }
    }

    static fromJS(data: any): ThermoProbeSettingsObjectParam {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoProbeSettingsObjectParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLedmanaged"] = this.isLedmanaged;
        data["externalSensorType"] = this.externalSensorType;
        data["isLedmanagedVisible"] = this.isLedmanagedVisible;
        data["isExternalSensorTypeVisible"] = this.isExternalSensorTypeVisible;
        return data; 
    }
}

export interface IThermoProbeSettingsObjectParam {
    isLedmanaged?: boolean;
    externalSensorType?: ExternalSensorType;
    isLedmanagedVisible?: boolean;
    isExternalSensorTypeVisible?: boolean;
}

export class ThermoRoomObjectDTO implements IThermoRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    heatingSystemControlType?: SystemControlType;
    coolingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    configurationSteps?: number;
    nextStep?: number;
    objectDuplication?: ObjectDuplication;
    resetType?: ResetType;
    newRoom?: Room;
    isDetailDeviceFlow?: boolean;
    isCompromised?: boolean;
    isApplyAllTemperatureRange?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    isApplyAllCirculationPumpDelay?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    isApplyAllCelsiusFahrenheit?: boolean;
    temperatureType?: TemperatureType;
    isApplyAllButtonsManagement?: boolean;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isApplyAllBacklight?: boolean;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isApplyAllWindowsContact?: boolean;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isInterlockingExcluded?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    pumpsDelay?: string;
    thermoUKFanSpeed?: number;
    thermoUKFanSpeed2?: number;
    thermoUKFanSpeed3?: number;
    plantId?: string | undefined;
    roomId?: string | undefined;
    extDevices?: ExtDevice[] | undefined;
    roomObjectType?: RoomObjectType;
    isNotFullyConfigured?: boolean;
    isEdit?: boolean;
    isApplyAllTemperatureVisualization?: boolean;
    isTemperatureDisplayed?: boolean;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    thermoOldInformation?: ThermoOldInformation;
    thermo?: ThermoActuactor[] | undefined;
    tempAddressPumps?: AddressPumps[] | undefined;
    isContactInError?: boolean;

    constructor(data?: IThermoRoomObjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            this.type = _data["type"];
            this.thermoTypeOfObject = _data["thermoTypeOfObject"];
            this.thermoAssociatedPump = _data["thermoAssociatedPump"];
            this.actuatorModalityType = _data["actuatorModalityType"];
            this.heatingSystemControlType = _data["heatingSystemControlType"];
            this.coolingSystemControlType = _data["coolingSystemControlType"];
            this.sharedSystemControlType = _data["sharedSystemControlType"];
            this.configurationSteps = _data["configurationSteps"];
            this.nextStep = _data["nextStep"];
            this.objectDuplication = _data["objectDuplication"];
            this.resetType = _data["resetType"];
            this.newRoom = _data["newRoom"] ? Room.fromJS(_data["newRoom"]) : <any>undefined;
            this.isDetailDeviceFlow = _data["isDetailDeviceFlow"];
            this.isCompromised = _data["isCompromised"];
            this.isApplyAllTemperatureRange = _data["isApplyAllTemperatureRange"];
            this.heatingSetpointLow = _data["heatingSetpointLow"];
            this.heatingSetpointHigh = _data["heatingSetpointHigh"];
            this.heatingAntifreeze = _data["heatingAntifreeze"];
            this.coolingSetpointLow = _data["coolingSetpointLow"];
            this.coolingSetpointHigh = _data["coolingSetpointHigh"];
            this.coolingThermalProtection = _data["coolingThermalProtection"];
            this.isAutoCommutation = _data["isAutoCommutation"];
            this.isApplyAllCirculationPumpDelay = _data["isApplyAllCirculationPumpDelay"];
            this.delayHeatingPumps = _data["delayHeatingPumps"];
            this.delayCoolingPumps = _data["delayCoolingPumps"];
            this.isApplyAllCelsiusFahrenheit = _data["isApplyAllCelsiusFahrenheit"];
            this.temperatureType = _data["temperatureType"];
            this.isApplyAllButtonsManagement = _data["isApplyAllButtonsManagement"];
            this.areButtonsEnabled = _data["areButtonsEnabled"];
            this.externalSensorType = _data["externalSensorType"];
            this.isApplyAllBacklight = _data["isApplyAllBacklight"];
            this.isBacklightEnabled = _data["isBacklightEnabled"];
            this.backlightLevel = _data["backlightLevel"];
            this.isManualHeatingOverrideEnabled = _data["isManualHeatingOverrideEnabled"];
            this.heatingRegulationBand = _data["heatingRegulationBand"];
            this.fanSpeed2ForHeating = _data["fanSpeed2ForHeating"];
            this.fanSpeed3ForHeating = _data["fanSpeed3ForHeating"];
            this.valvesTimeForHeatingFanCoil = _data["valvesTimeForHeatingFanCoil"];
            this.isManualCoolingOverrideEnabled = _data["isManualCoolingOverrideEnabled"];
            this.coolingRegulationBand = _data["coolingRegulationBand"];
            this.fanSpeed2ForCooling = _data["fanSpeed2ForCooling"];
            this.fanSpeed3ForCooling = _data["fanSpeed3ForCooling"];
            this.valvesTimeForCoolingFanCoil = _data["valvesTimeForCoolingFanCoil"];
            this.isApplyAllWindowsContact = _data["isApplyAllWindowsContact"];
            this.isIconAlwaysOff = _data["isIconAlwaysOff"];
            this.isLocalContactNumberEnabled = _data["isLocalContactNumberEnabled"];
            this.numberOfWindowsContact = _data["numberOfWindowsContact"];
            this.openingContactTypeHeating = _data["openingContactTypeHeating"];
            this.openingContactTempHeating = _data["openingContactTempHeating"];
            this.openingContactDelayHeating = _data["openingContactDelayHeating"];
            this.timeoutOpeningHeating = _data["timeoutOpeningHeating"];
            this.closingContactTypeHeating = _data["closingContactTypeHeating"];
            this.closingContactTempHeating = _data["closingContactTempHeating"];
            this.closingContactDelayHeating = _data["closingContactDelayHeating"];
            this.timeoutClosingHeating = _data["timeoutClosingHeating"];
            this.openingContactTypeCooling = _data["openingContactTypeCooling"];
            this.openingContactTempCooling = _data["openingContactTempCooling"];
            this.openingContactDelayCooling = _data["openingContactDelayCooling"];
            this.timeoutOpeningCooling = _data["timeoutOpeningCooling"];
            this.closingContactTypeCooling = _data["closingContactTypeCooling"];
            this.closingContactTempCooling = _data["closingContactTempCooling"];
            this.closingContactDelayCooling = _data["closingContactDelayCooling"];
            this.timeoutClosingCooling = _data["timeoutClosingCooling"];
            this.isInterlockingExcluded = _data["isInterlockingExcluded"];
            this.isWaterCycleEnabled = _data["isWaterCycleEnabled"];
            this.arePumpsOpenedAutomatically = _data["arePumpsOpenedAutomatically"];
            this.minutesToKeepOpen = _data["minutesToKeepOpen"];
            this.openAutomaticallyDaysDelay = _data["openAutomaticallyDaysDelay"];
            this.pumpsDelay = _data["pumpsDelay"];
            this.thermoUKFanSpeed = _data["thermoUKFanSpeed"];
            this.thermoUKFanSpeed2 = _data["thermoUKFanSpeed2"];
            this.thermoUKFanSpeed3 = _data["thermoUKFanSpeed3"];
            this.plantId = _data["plantId"];
            this.roomId = _data["roomId"];
            if (Array.isArray(_data["extDevices"])) {
                this.extDevices = [] as any;
                for (let item of _data["extDevices"])
                    this.extDevices!.push(ExtDevice.fromJS(item));
            }
            this.roomObjectType = _data["roomObjectType"];
            this.isNotFullyConfigured = _data["isNotFullyConfigured"];
            this.isEdit = _data["isEdit"];
            this.isApplyAllTemperatureVisualization = _data["isApplyAllTemperatureVisualization"];
            this.isTemperatureDisplayed = _data["isTemperatureDisplayed"];
            this.isCoolingVentilationEnabled = _data["isCoolingVentilationEnabled"];
            this.isHeatingVentilationEnabled = _data["isHeatingVentilationEnabled"];
            this.timeoutCoolingVentilation = _data["timeoutCoolingVentilation"];
            this.timeoutHeatingVentilation = _data["timeoutHeatingVentilation"];
            this.thermoOldInformation = _data["thermoOldInformation"] ? ThermoOldInformation.fromJS(_data["thermoOldInformation"]) : <any>undefined;
            if (Array.isArray(_data["thermo"])) {
                this.thermo = [] as any;
                for (let item of _data["thermo"])
                    this.thermo!.push(ThermoActuactor.fromJS(item));
            }
            if (Array.isArray(_data["tempAddressPumps"])) {
                this.tempAddressPumps = [] as any;
                for (let item of _data["tempAddressPumps"])
                    this.tempAddressPumps!.push(AddressPumps.fromJS(item));
            }
            this.isContactInError = _data["isContactInError"];
        }
    }

    static fromJS(data: any): ThermoRoomObjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThermoRoomObjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["thermoTypeOfObject"] = this.thermoTypeOfObject;
        data["thermoAssociatedPump"] = this.thermoAssociatedPump;
        data["actuatorModalityType"] = this.actuatorModalityType;
        data["heatingSystemControlType"] = this.heatingSystemControlType;
        data["coolingSystemControlType"] = this.coolingSystemControlType;
        data["sharedSystemControlType"] = this.sharedSystemControlType;
        data["configurationSteps"] = this.configurationSteps;
        data["nextStep"] = this.nextStep;
        data["objectDuplication"] = this.objectDuplication;
        data["resetType"] = this.resetType;
        data["newRoom"] = this.newRoom ? this.newRoom.toJSON() : <any>undefined;
        data["isDetailDeviceFlow"] = this.isDetailDeviceFlow;
        data["isCompromised"] = this.isCompromised;
        data["isApplyAllTemperatureRange"] = this.isApplyAllTemperatureRange;
        data["heatingSetpointLow"] = this.heatingSetpointLow;
        data["heatingSetpointHigh"] = this.heatingSetpointHigh;
        data["heatingAntifreeze"] = this.heatingAntifreeze;
        data["coolingSetpointLow"] = this.coolingSetpointLow;
        data["coolingSetpointHigh"] = this.coolingSetpointHigh;
        data["coolingThermalProtection"] = this.coolingThermalProtection;
        data["isAutoCommutation"] = this.isAutoCommutation;
        data["isApplyAllCirculationPumpDelay"] = this.isApplyAllCirculationPumpDelay;
        data["delayHeatingPumps"] = this.delayHeatingPumps;
        data["delayCoolingPumps"] = this.delayCoolingPumps;
        data["isApplyAllCelsiusFahrenheit"] = this.isApplyAllCelsiusFahrenheit;
        data["temperatureType"] = this.temperatureType;
        data["isApplyAllButtonsManagement"] = this.isApplyAllButtonsManagement;
        data["areButtonsEnabled"] = this.areButtonsEnabled;
        data["externalSensorType"] = this.externalSensorType;
        data["isApplyAllBacklight"] = this.isApplyAllBacklight;
        data["isBacklightEnabled"] = this.isBacklightEnabled;
        data["backlightLevel"] = this.backlightLevel;
        data["isManualHeatingOverrideEnabled"] = this.isManualHeatingOverrideEnabled;
        data["heatingRegulationBand"] = this.heatingRegulationBand;
        data["fanSpeed2ForHeating"] = this.fanSpeed2ForHeating;
        data["fanSpeed3ForHeating"] = this.fanSpeed3ForHeating;
        data["valvesTimeForHeatingFanCoil"] = this.valvesTimeForHeatingFanCoil;
        data["isManualCoolingOverrideEnabled"] = this.isManualCoolingOverrideEnabled;
        data["coolingRegulationBand"] = this.coolingRegulationBand;
        data["fanSpeed2ForCooling"] = this.fanSpeed2ForCooling;
        data["fanSpeed3ForCooling"] = this.fanSpeed3ForCooling;
        data["valvesTimeForCoolingFanCoil"] = this.valvesTimeForCoolingFanCoil;
        data["isApplyAllWindowsContact"] = this.isApplyAllWindowsContact;
        data["isIconAlwaysOff"] = this.isIconAlwaysOff;
        data["isLocalContactNumberEnabled"] = this.isLocalContactNumberEnabled;
        data["numberOfWindowsContact"] = this.numberOfWindowsContact;
        data["openingContactTypeHeating"] = this.openingContactTypeHeating;
        data["openingContactTempHeating"] = this.openingContactTempHeating;
        data["openingContactDelayHeating"] = this.openingContactDelayHeating;
        data["timeoutOpeningHeating"] = this.timeoutOpeningHeating;
        data["closingContactTypeHeating"] = this.closingContactTypeHeating;
        data["closingContactTempHeating"] = this.closingContactTempHeating;
        data["closingContactDelayHeating"] = this.closingContactDelayHeating;
        data["timeoutClosingHeating"] = this.timeoutClosingHeating;
        data["openingContactTypeCooling"] = this.openingContactTypeCooling;
        data["openingContactTempCooling"] = this.openingContactTempCooling;
        data["openingContactDelayCooling"] = this.openingContactDelayCooling;
        data["timeoutOpeningCooling"] = this.timeoutOpeningCooling;
        data["closingContactTypeCooling"] = this.closingContactTypeCooling;
        data["closingContactTempCooling"] = this.closingContactTempCooling;
        data["closingContactDelayCooling"] = this.closingContactDelayCooling;
        data["timeoutClosingCooling"] = this.timeoutClosingCooling;
        data["isInterlockingExcluded"] = this.isInterlockingExcluded;
        data["isWaterCycleEnabled"] = this.isWaterCycleEnabled;
        data["arePumpsOpenedAutomatically"] = this.arePumpsOpenedAutomatically;
        data["minutesToKeepOpen"] = this.minutesToKeepOpen;
        data["openAutomaticallyDaysDelay"] = this.openAutomaticallyDaysDelay;
        data["pumpsDelay"] = this.pumpsDelay;
        data["thermoUKFanSpeed"] = this.thermoUKFanSpeed;
        data["thermoUKFanSpeed2"] = this.thermoUKFanSpeed2;
        data["thermoUKFanSpeed3"] = this.thermoUKFanSpeed3;
        data["plantId"] = this.plantId;
        data["roomId"] = this.roomId;
        if (Array.isArray(this.extDevices)) {
            data["extDevices"] = [];
            for (let item of this.extDevices)
                data["extDevices"].push(item.toJSON());
        }
        data["roomObjectType"] = this.roomObjectType;
        data["isNotFullyConfigured"] = this.isNotFullyConfigured;
        data["isEdit"] = this.isEdit;
        data["isApplyAllTemperatureVisualization"] = this.isApplyAllTemperatureVisualization;
        data["isTemperatureDisplayed"] = this.isTemperatureDisplayed;
        data["isCoolingVentilationEnabled"] = this.isCoolingVentilationEnabled;
        data["isHeatingVentilationEnabled"] = this.isHeatingVentilationEnabled;
        data["timeoutCoolingVentilation"] = this.timeoutCoolingVentilation;
        data["timeoutHeatingVentilation"] = this.timeoutHeatingVentilation;
        data["thermoOldInformation"] = this.thermoOldInformation ? this.thermoOldInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.thermo)) {
            data["thermo"] = [];
            for (let item of this.thermo)
                data["thermo"].push(item.toJSON());
        }
        if (Array.isArray(this.tempAddressPumps)) {
            data["tempAddressPumps"] = [];
            for (let item of this.tempAddressPumps)
                data["tempAddressPumps"].push(item.toJSON());
        }
        data["isContactInError"] = this.isContactInError;
        return data; 
    }
}

export interface IThermoRoomObjectDTO {
    id?: string | undefined;
    name?: string | undefined;
    devices?: DeviceDTO[] | undefined;
    type?: RoomObjectType;
    thermoTypeOfObject?: ThermoTypeOfObject;
    thermoAssociatedPump?: ThermoAssociatedPump;
    actuatorModalityType?: ActuatorModalityType;
    heatingSystemControlType?: SystemControlType;
    coolingSystemControlType?: SystemControlType;
    sharedSystemControlType?: SystemControlType;
    configurationSteps?: number;
    nextStep?: number;
    objectDuplication?: ObjectDuplication;
    resetType?: ResetType;
    newRoom?: Room;
    isDetailDeviceFlow?: boolean;
    isCompromised?: boolean;
    isApplyAllTemperatureRange?: boolean;
    heatingSetpointLow?: number;
    heatingSetpointHigh?: number;
    heatingAntifreeze?: number;
    coolingSetpointLow?: number;
    coolingSetpointHigh?: number;
    coolingThermalProtection?: number;
    isAutoCommutation?: boolean;
    isApplyAllCirculationPumpDelay?: boolean;
    delayHeatingPumps?: string;
    delayCoolingPumps?: string;
    isApplyAllCelsiusFahrenheit?: boolean;
    temperatureType?: TemperatureType;
    isApplyAllButtonsManagement?: boolean;
    areButtonsEnabled?: boolean;
    externalSensorType?: ExternalSensorType;
    isApplyAllBacklight?: boolean;
    isBacklightEnabled?: boolean;
    backlightLevel?: number;
    isManualHeatingOverrideEnabled?: boolean;
    heatingRegulationBand?: number;
    fanSpeed2ForHeating?: number;
    fanSpeed3ForHeating?: number;
    valvesTimeForHeatingFanCoil?: string;
    isManualCoolingOverrideEnabled?: boolean;
    coolingRegulationBand?: number;
    fanSpeed2ForCooling?: number;
    fanSpeed3ForCooling?: number;
    valvesTimeForCoolingFanCoil?: string;
    isApplyAllWindowsContact?: boolean;
    isIconAlwaysOff?: boolean;
    isLocalContactNumberEnabled?: boolean;
    numberOfWindowsContact?: number;
    openingContactTypeHeating?: ContactType;
    openingContactTempHeating?: number;
    openingContactDelayHeating?: string;
    timeoutOpeningHeating?: string;
    closingContactTypeHeating?: ContactType;
    closingContactTempHeating?: number;
    closingContactDelayHeating?: string;
    timeoutClosingHeating?: string;
    openingContactTypeCooling?: ContactType;
    openingContactTempCooling?: number;
    openingContactDelayCooling?: string;
    timeoutOpeningCooling?: string;
    closingContactTypeCooling?: ContactType;
    closingContactTempCooling?: number;
    closingContactDelayCooling?: string;
    timeoutClosingCooling?: string;
    isInterlockingExcluded?: boolean;
    isWaterCycleEnabled?: boolean;
    arePumpsOpenedAutomatically?: boolean;
    minutesToKeepOpen?: string;
    openAutomaticallyDaysDelay?: number;
    pumpsDelay?: string;
    thermoUKFanSpeed?: number;
    thermoUKFanSpeed2?: number;
    thermoUKFanSpeed3?: number;
    plantId?: string | undefined;
    roomId?: string | undefined;
    extDevices?: ExtDevice[] | undefined;
    roomObjectType?: RoomObjectType;
    isNotFullyConfigured?: boolean;
    isEdit?: boolean;
    isApplyAllTemperatureVisualization?: boolean;
    isTemperatureDisplayed?: boolean;
    isCoolingVentilationEnabled?: boolean;
    isHeatingVentilationEnabled?: boolean;
    timeoutCoolingVentilation?: string;
    timeoutHeatingVentilation?: string;
    thermoOldInformation?: ThermoOldInformation;
    thermo?: ThermoActuactor[] | undefined;
    tempAddressPumps?: AddressPumps[] | undefined;
    isContactInError?: boolean;
}

/** 0 = None 1 = Heating 2 = Cooling 3 = HeatingAndCooling */
export enum ThermoTypeOfObject {
    None = 0,
    Heating = 1,
    Cooling = 2,
    HeatingAndCooling = 3,
}

/** 0 = Off 1 = Heat 2 = Cool 3 = Auto 4 = None */
export enum ThermostatStatus {
    Off = 0,
    Heat = 1,
    Cool = 2,
    Auto = 3,
    None = 4,
}

export class TimeCondition extends Condition implements ITimeCondition {
    startTime?: string;
    endTime?: string;
    weekDays?: WeekDay[] | undefined;

    constructor(data?: ITimeCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays!.push(item);
            }
        }
    }

    static fromJS(data: any): TimeCondition {
        data = typeof data === 'object' ? data : {};
        let result = new TimeCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITimeCondition extends ICondition {
    startTime?: string;
    endTime?: string;
    weekDays?: WeekDay[] | undefined;
}

/** 0 = None 1 = Onedirection 2 = Boththedirections */
export enum ToroidDirection {
    None = 0,
    Onedirection = 1,
    Boththedirections = 2,
}

export class WaitTimeAction extends Action implements IWaitTimeAction {
    waitTime?: string;

    constructor(data?: IWaitTimeAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.waitTime = _data["waitTime"];
        }
    }

    static fromJS(data: any): WaitTimeAction {
        data = typeof data === 'object' ? data : {};
        let result = new WaitTimeAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitTime"] = this.waitTime;
        super.toJSON(data);
        return data; 
    }
}

export interface IWaitTimeAction extends IAction {
    waitTime?: string;
}

export class WeatherCondition extends Condition implements IWeatherCondition {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;

    constructor(data?: IWeatherCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weatherStateComparer = _data["weatherStateComparer"];
            this.weatherTemperature = _data["weatherTemperature"];
            this.sceneWeatherModality = _data["sceneWeatherModality"];
            this.weatherWindSpeed = _data["weatherWindSpeed"];
            this.humidityPercentage = _data["humidityPercentage"];
            this.sceneWeatherForecastState = _data["sceneWeatherForecastState"];
            this.sceneWeatherCrepuscular = _data["sceneWeatherCrepuscular"];
        }
    }

    static fromJS(data: any): WeatherCondition {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weatherStateComparer"] = this.weatherStateComparer;
        data["weatherTemperature"] = this.weatherTemperature;
        data["sceneWeatherModality"] = this.sceneWeatherModality;
        data["weatherWindSpeed"] = this.weatherWindSpeed;
        data["humidityPercentage"] = this.humidityPercentage;
        data["sceneWeatherForecastState"] = this.sceneWeatherForecastState;
        data["sceneWeatherCrepuscular"] = this.sceneWeatherCrepuscular;
        super.toJSON(data);
        return data; 
    }
}

export interface IWeatherCondition extends ICondition {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;
}

export class WeatherTrigger extends Trigger implements IWeatherTrigger {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;

    constructor(data?: IWeatherTrigger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weatherStateComparer = _data["weatherStateComparer"];
            this.weatherTemperature = _data["weatherTemperature"];
            this.sceneWeatherModality = _data["sceneWeatherModality"];
            this.weatherWindSpeed = _data["weatherWindSpeed"];
            this.humidityPercentage = _data["humidityPercentage"];
            this.sceneWeatherForecastState = _data["sceneWeatherForecastState"];
            this.sceneWeatherCrepuscular = _data["sceneWeatherCrepuscular"];
        }
    }

    static fromJS(data: any): WeatherTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weatherStateComparer"] = this.weatherStateComparer;
        data["weatherTemperature"] = this.weatherTemperature;
        data["sceneWeatherModality"] = this.sceneWeatherModality;
        data["weatherWindSpeed"] = this.weatherWindSpeed;
        data["humidityPercentage"] = this.humidityPercentage;
        data["sceneWeatherForecastState"] = this.sceneWeatherForecastState;
        data["sceneWeatherCrepuscular"] = this.sceneWeatherCrepuscular;
        super.toJSON(data);
        return data; 
    }
}

export interface IWeatherTrigger extends ITrigger {
    weatherStateComparer?: SceneStateComparer;
    weatherTemperature?: number;
    sceneWeatherModality?: SceneWeatherModality;
    weatherWindSpeed?: number;
    humidityPercentage?: number;
    sceneWeatherForecastState?: SceneWeatherForecastState;
    sceneWeatherCrepuscular?: SceneWeatherCrepuscular;
}

/** 0 = Monday 1 = Tuesday 2 = Wednesday 3 = Thursday 4 = Friday 5 = Saturday 6 = Sunday */
export enum WeekDay {
    Monday = 0,
    Tuesday = 1,
    Wednesday = 2,
    Thursday = 3,
    Friday = 4,
    Saturday = 5,
    Sunday = 6,
}

export class XmeterExtDevice extends ExtDevice implements IXmeterExtDevice {
    readonly address?: string | undefined;

    constructor(data?: IXmeterExtDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            (<any>this).address = _data["address"];
        }
    }

    static fromJS(data: any): XmeterExtDevice {
        data = typeof data === 'object' ? data : {};
        let result = new XmeterExtDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        super.toJSON(data);
        return data; 
    }
}

export interface IXmeterExtDevice extends IExtDevice {
    address?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}